const toolsData = [
  {
    "id": "chatbots",
    "name": "ChatGPT Alternatives",
    "tools": [
      {
        "name": "ChatGPT",
        "pricing": "Freemium",
        "description": "ChatGPT-4o is OpenAI's fastest and smartest AI model yet.",
        "url": "https://www.ChatGPT.com",
        "icon": "fas fa-comment-alt",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973796/chatgpt_m0mums.jpg",
        "dateAdded": 1667260800000,
        "tags": [
          "chatgpt ai",
          "chatgpt alternatives",
          "freemium",
          "chatgpt",
          "chatgpt4o",
          "openais",
          "fastest",
          "smartest",
          "yet"
        ],
        "rating": 4.8,
        "reviewCount": "12,500+"
      },
      {
        "name": "EasyPeasy AI",
        "pricing": "Freemium",
        "description": "The fastest way to get work done with generative AI.",
        "url": "https://easy-peasy.ai/",
        "icon": "fas fa-comment-alt",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976446/easypeasy_alupqi.jpg",
        "dateAdded": 1667260800000,
        "tags": [
          "easypeasy ai",
          "chatgpt alternatives",
          "freemium",
          "easypeasy",
          "fastest",
          "get",
          "work",
          "done",
          "generative"
        ],
        "rating": 4.1,
        "reviewCount": "354+"
      },
      {
        "name": "Perplexity AI",
        "pricing": "Freemium",
        "description": "AI search engine that answers queries using natural language.",
        "url": "https://www.perplexity.ai",
        "icon": "fas fa-comment-alt",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986938/Perplexity_ymzvod.jpg",
        "dateAdded": 1667520000000,
        "tags": [
          "perplexity ai",
          "chatgpt alternatives",
          "freemium",
          "perplexity",
          "search",
          "engine",
          "answers",
          "queries",
          "natural",
          "language"
        ],
        "rating": 4.8,
        "reviewCount": "3,400+"
      },
      {
        "name": "Cohesive",
        "pricing": "Freemium",
        "description": "ChatGPT on steroids with better workflow tools.",
        "url": "https://www.cohesive.so",
        "icon": "fas fa-comment-alt",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973946/Cohesive_suscsq.jpg",
        "dateAdded": 1667692800000,
        "tags": [
          "cohesive",
          "chatgpt alternatives",
          "freemium",
          "chatgpt",
          "steroids",
          "workflow",
          "tools"
        ],
        "rating": 4,
        "reviewCount": "160+"
      },
      {
        "name": "GPTGO",
        "pricing": "Freemium",
        "description": "Google + GPT combo tool.",
        "url": "https://gptgo.ai",
        "icon": "fas fa-comment-alt",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983260/gptgo_tajtqi.jpg",
        "dateAdded": 1667779200000,
        "tags": [
          "gptgo",
          "chatgpt alternatives",
          "freemium",
          "google",
          "gpt",
          "combo"
        ],
        "rating": 4.8,
        "reviewCount": "276+"
      },
      {
        "name": "AIPRM",
        "pricing": "Freemium",
        "description": "Over 2,500 free ChatGPT prompts.",
        "url": "https://www.aiprm.com",
        "icon": "fas fa-comment-alt",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972180/Aiprm_ahxw8v.jpg",
        "dateAdded": 1668124800000,
        "tags": [
          "aiprm",
          "chatgpt alternatives",
          "freemium",
          "over",
          "2500",
          "chatgpt",
          "prompts"
        ],
        "rating": 4.4,
        "reviewCount": "132+"
      },
      {
        "name": "Grok",
        "pricing": "Freemium",
        "description": "AI assistant by xAI, witty and truth-seeking.",
        "icon": "fas fa-comment-alt",
        "url": "https://x.ai/grok",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983181/Grok_ifgosi.jpg",
        "dateAdded": 1668297600000,
        "tags": [
          "grok",
          "chatgpt alternatives",
          "freemium",
          "assistant",
          "xai",
          "witty",
          "truthseeking"
        ],
        "rating": 4.5,
        "reviewCount": "2,200+"
      },
      {
        "name": "Claude",
        "pricing": "Freemium",
        "description": "Conversational AI by Anthropic, safe and helpful.",
        "icon": "fas fa-comment-alt",
        "url": "https://claude.ai/new",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973912/Claude_xsp1b3.jpg",
        "dateAdded": 1668729600000,
        "tags": [
          "claude",
          "chatgpt alternatives",
          "freemium",
          "conversational",
          "anthropic",
          "safe",
          "helpful"
        ],
        "rating": 4.7,
        "reviewCount": "1,800+"
      },
      {
        "name": "Gemini (Bard)",
        "pricing": "Freemium",
        "description": "Google’s most advanced AI, now branded Gemini, with Search integration.",
        "icon": "fas fa-comment-alt",
        "url": "https://gemini.google.com/",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983239/Gemini_aljiac.jpg",
        "dateAdded": 1669248000000,
        "tags": [
          "gemini (bard)",
          "chatgpt alternatives",
          "freemium",
          "gemini",
          "bard",
          "googles",
          "branded",
          "search",
          "integration"
        ],
        "rating": 4.2,
        "reviewCount": "126+"
      },
      {
        "name": "Pi (HeyPi)",
        "pricing": "Freemium",
        "description": "Emotional intelligence and supportive conversations.",
        "icon": "fas fa-comment-alt",
        "url": "https://pi.ai/onboarding",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763987398/pi_bcbboo.jpg",
        "dateAdded": 1669334400000,
        "tags": [
          "pi (heypi)",
          "chatgpt alternatives",
          "freemium",
          "heypi",
          "emotional",
          "intelligence",
          "supportive",
          "conversations"
        ],
        "rating": 4.3,
        "reviewCount": "254+"
      },
      {
        "name": "Chatsonic",
        "pricing": "Freemium",
        "description": "Real-time info, voice input, GPT-based.",
        "icon": "fas fa-comment-alt",
        "url": "https://chatsonic.io/",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973910/ChatSonic_ghjizi.jpg",
        "dateAdded": 1669766400000,
        "tags": [
          "chatsonic",
          "chatgpt alternatives",
          "freemium",
          "realtime",
          "info",
          "voice",
          "input",
          "gptbased"
        ],
        "rating": 4.8,
        "reviewCount": "455+"
      },
      {
        "name": "Poe",
        "pricing": "Freemium",
        "description": "Aggregates GPT-4, Claude, Gemini, etc., into one interface.",
        "icon": "fas fa-comment-alt",
        "url": "https://poe.com/login",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763988689/poe_xbyi8r.jpg",
        "dateAdded": 1670716800000,
        "tags": [
          "poe",
          "chatgpt alternatives",
          "freemium",
          "aggregates",
          "gpt4",
          "claude",
          "gemini",
          "into",
          "one",
          "interface"
        ],
        "rating": 4.4,
        "reviewCount": "445+"
      },
      {
        "name": "Mistral Chat",
        "pricing": "Freemium",
        "description": "Extremely fast and responsive using open LLMs.",
        "icon": "fas fa-comment-alt",
        "url": "https://chat.mistral.ai/chat",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986043/Mistral_dsmgjg.jpg",
        "dateAdded": 1670803200000,
        "tags": [
          "mistral chat",
          "chatgpt alternatives",
          "freemium",
          "mistral",
          "chat",
          "extremely",
          "responsive",
          "open",
          "llms"
        ],
        "rating": 4.8,
        "reviewCount": "190+"
      },
      {
        "name": "DeepSeek-R1",
        "pricing": "Open Source",
        "description": "Open-source, strong reasoning capabilities, efficient performance & Completely free to use.",
        "icon": "fas fa-comment-alt",
        "url": "https://www.deepseek.com/en",
        "isNew": false,
        "comingSoon": false,
        "badge": "Not Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763975500/Deepseek_qjehu9.jpg",
        "dateAdded": 1670889600000,
        "tags": [
          "deepseek-r1",
          "chatgpt alternatives",
          "open source",
          "deepseekr1",
          "opensource",
          "strong",
          "reasoning",
          "capabilities",
          "efficient",
          "performance",
          "completely"
        ],
        "rating": 4.6,
        "reviewCount": "1,500+"
      },
      {
        "name": "Kiro",
        "pricing": "Freemium",
        "description": "Fast, keyboard-first AI assistant tailored for developers. Works locally with your code, privacy-first, no sign-up needed.",
        "icon": "fas fa-code",
        "url": "https://kiro.dev",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984857/Kiro_xiwfwd.jpg",
        "dateAdded": 1670976000000,
        "tags": [
          "kiro",
          "chatgpt alternatives",
          "freemium",
          "keyboardfirst",
          "assistant",
          "tailored",
          "developers",
          "works",
          "locally",
          "your",
          "code",
          "privacyfirst",
          "signup",
          "needed"
        ],
        "rating": 4.7,
        "reviewCount": "300+"
      },
      {
        "name": "Kimi",
        "pricing": "Freemium",
        "description": "Powerful, open‑source AI assistant built on Moonshot AI’s K2 model—supports code, deep reasoning, multimodal understanding & large-context workflows.",
        "icon": "fas fa-robot",
        "url": "https://www.kimi.com",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984818/kimi_je3pxp.jpg",
        "dateAdded": 1671235200000,
        "tags": [
          "kimi",
          "chatgpt alternatives",
          "freemium",
          "opensource",
          "assistant",
          "moonshot",
          "ais",
          "modelsupports",
          "code",
          "deep",
          "reasoning",
          "multimodal",
          "understanding",
          "largecontext",
          "workflows"
        ],
        "rating": 4.4,
        "reviewCount": "199+"
      },
      {
        "name": "ChatGPT Free AI",
        "pricing": "Freemium",
        "description": "Free ChatGPT alternative with no login required. Access powerful GPT-4-like chat experience in your browser anytime.",
        "icon": "fas fa-comments",
        "url": "https://chatgptfree.ai/chat/",
        "isNew": true,
        "comingSoon": false,
        "badge": "Free",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973798/Chatgptfree_tpkukz.jpg",
        "dateAdded": 1672963200000,
        "tags": [
          "chatgpt free ai",
          "chatgpt alternatives",
          "freemium",
          "chatgpt",
          "alternative",
          "login",
          "required",
          "access",
          "gpt4like",
          "chat",
          "experience",
          "your",
          "browser",
          "anytime"
        ],
        "rating": 4.8,
        "reviewCount": "12,500+"
      },
      {
        "name": "ChatSimple",
        "pricing": "Freemium",
        "description": "No-code AI chatbot builder designed for small businesses to automate lead generation and customer support.",
        "icon": "fas fa-comments",
        "url": "https://www.chatsimple.ai/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973803/ChatSimple_d1tbr5.jpg",
        "dateAdded": 1673308800000,
        "tags": [
          "chatsimple",
          "chatgpt alternatives",
          "freemium",
          "nocode",
          "chatbot",
          "builder",
          "businesses",
          "automate",
          "lead",
          "generation",
          "customer"
        ],
        "rating": 4.7,
        "reviewCount": "215+"
      },
      {
        "name": "Chatbase",
        "pricing": "Freemium",
        "description": "Tool to train custom AI chatbots on your data and embed them on websites for automated customer support or engagement.",
        "icon": "fas fa-database",
        "url": "https://www.chatbase.co/",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973795/Chatbase_lxyjir.jpg",
        "dateAdded": 1673827200000,
        "tags": [
          "chatbase",
          "chatgpt alternatives",
          "freemium",
          "train",
          "custom",
          "chatbots",
          "your",
          "data",
          "embed",
          "them",
          "websites",
          "customer",
          "engagement"
        ],
        "rating": 4.6,
        "reviewCount": "387+"
      },
      {
        "name": "Minimax Chat",
        "pricing": "Freemium",
        "description": "AI chatbot by Minimax for Chinese users. Offers natural and fluent conversational experience powered by large language models.",
        "icon": "fas fa-robot",
        "url": "https://chat.minimax.io/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986038/Minimax_ck3sru.jpg",
        "dateAdded": 1673913600000,
        "tags": [
          "minimax chat",
          "chatgpt alternatives",
          "freemium",
          "minimax",
          "chat",
          "chatbot",
          "chinese",
          "natural",
          "fluent",
          "conversational",
          "experience",
          "language"
        ],
        "rating": 4,
        "reviewCount": "195+"
      }
    ]
  },
  {
    "id": "text-humanizer-ai",
    "name": "Text Humanizer AI Tools",
    "tools": [
      {
        "name": "Humanize AI Text",
        "pricing": "Freemium",
        "description": "Convert robotic or AI-generated content into natural, human-like text that sounds authentic and engaging.",
        "url": "https://www.humanizeaitext.org",
        "icon": "fas fa-user-edit",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984010/humanizeaitext_rdce1l.jpg",
        "dateAdded": 1674172800000,
        "tags": [
          "humanize ai text",
          "text humanizer ai",
          "freemium",
          "humanize",
          "text",
          "convert",
          "robotic",
          "aigenerated",
          "content",
          "into",
          "natural",
          "humanlike",
          "sounds",
          "authentic",
          "engaging"
        ],
        "rating": 4.1,
        "reviewCount": "287+"
      },
      {
        "name": "Hume.ai",
        "pricing": "Freemium",
        "description": "Empathy-driven AI that enhances your text by adding emotional intelligence and human tone.",
        "url": "https://www.hume.ai",
        "icon": "fas fa-heart",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983989/Hume_m4wryk.jpg",
        "dateAdded": 1674432000000,
        "tags": [
          "hume.ai",
          "text humanizer ai",
          "freemium",
          "humeai",
          "empathydriven",
          "enhances",
          "your",
          "text",
          "adding",
          "emotional",
          "intelligence",
          "human",
          "tone"
        ],
        "rating": 4.6,
        "reviewCount": "74+"
      },
      {
        "name": "Quillbot Humanizer",
        "pricing": "Freemium",
        "description": "Refines and rewrites AI-generated text to sound more natural using advanced paraphrasing models.",
        "url": "https://quillbot.com",
        "icon": "fas fa-pen-nib",
        "comingSoon": false,
        "badge": "New",
        "isNew": true,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989080/Quillbot_zhga5w.jpg",
        "dateAdded": 1674432000000,
        "tags": [
          "quillbot humanizer",
          "text humanizer ai",
          "freemium",
          "quillbot",
          "humanizer",
          "refines",
          "rewrites",
          "aigenerated",
          "text",
          "sound",
          "natural",
          "paraphrasing"
        ],
        "rating": 4.6,
        "reviewCount": "179+"
      },
      {
        "name": "BypassGPT",
        "pricing": "Freemium",
        "description": "Humanize AI-generated content to bypass detection tools while keeping the meaning intact and natural-sounding.",
        "url": "https://www.bypassgpt.ai/",
        "icon": "fas fa-user-secret",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972959/Bypassgpt_xpijob.jpg",
        "dateAdded": 1674691200000,
        "tags": [
          "bypassgpt",
          "text humanizer ai",
          "freemium",
          "humanize",
          "aigenerated",
          "content",
          "bypass",
          "detection",
          "tools",
          "while",
          "keeping",
          "meaning",
          "intact",
          "naturalsounding"
        ],
        "rating": 4.6,
        "reviewCount": "76+"
      },
      {
        "name": "HIX Bypass AI",
        "pricing": "Freemium",
        "description": "Make AI-generated text undetectable by AI detectors using advanced rewriting and humanizing techniques.",
        "url": "https://bypass.hix.ai/humanize-ai",
        "icon": "fas fa-user-edit",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983984/hix_w6nuau.jpg",
        "dateAdded": 1674691200000,
        "tags": [
          "hix bypass ai",
          "text humanizer ai",
          "freemium",
          "hix",
          "bypass",
          "aigenerated",
          "text",
          "undetectable",
          "detectors",
          "rewriting",
          "humanizing",
          "techniques"
        ],
        "rating": 4.8,
        "reviewCount": "138+"
      },
      {
        "name": "Jenni AI",
        "pricing": "Freemium",
        "description": "AI writing assistant that helps generate essays, articles, and academic content with real-time suggestions.",
        "icon": "fas fa-pen-nib",
        "url": "https://app.jenni.ai/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "recommended": true,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984402/jenni_w7t0ku.jpg",
        "dateAdded": 1674950400000,
        "tags": [
          "jenni ai",
          "text humanizer ai",
          "freemium",
          "jenni",
          "writing",
          "assistant",
          "helps",
          "essays",
          "articles",
          "academic",
          "content",
          "realtime",
          "suggestions"
        ],
        "rating": 4.2,
        "reviewCount": "69+"
      },
      {
        "name": "Text Blaze",
        "pricing": "Freemium",
        "description": "Productivity tool that allows you to automate repetitive typing using templates and text snippets.",
        "icon": "fas fa-keyboard",
        "url": "https://blaze.today/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "recommended": true,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990451/TextBlaze_lunmqn.jpg",
        "dateAdded": 1675468800000,
        "tags": [
          "text blaze",
          "text humanizer ai",
          "freemium",
          "text",
          "blaze",
          "productivity",
          "you",
          "automate",
          "repetitive",
          "typing",
          "templates",
          "snippets"
        ],
        "rating": 4.7,
        "reviewCount": "35+"
      }
    ]
  },
  {
    "id": "ai-coding-assistants",
    "name": "AI Coding Assistants",
    "tools": [
      {
        "name": "AskCodi",
        "pricing": "Free ",
        "description": "AI code assistant for developers to write code, tests, and documentation faster.",
        "url": "https://www.askcodi.com",
        "icon": "fas fa-code",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972181/askcodi_iwxbru.jpg",
        "dateAdded": 1677024000000,
        "tags": [
          "askcodi",
          "ai coding assistants",
          "free",
          "code",
          "assistant",
          "developers",
          "write",
          "tests",
          "documentation",
          "faster"
        ],
        "rating": 4.4,
        "reviewCount": "39+"
      },
      {
        "name": "Codiga",
        "pricing": "Freemium",
        "description": "Real-time static code analysis and automated code reviews in your IDE.",
        "url": "https://www.codiga.io",
        "icon": "fas fa-code",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973937/codiga_yvu0qh.jpg",
        "dateAdded": 1677801600000,
        "tags": [
          "codiga",
          "ai coding assistants",
          "freemium",
          "realtime",
          "static",
          "code",
          "analysis",
          "reviews",
          "your",
          "ide"
        ],
        "rating": 4.2,
        "reviewCount": "391+"
      },
      {
        "name": "Cursor",
        "pricing": "Freemium",
        "description": "An AI-first code editor designed for pair-programming with AI.",
        "url": "https://cursor.sh",
        "icon": "fas fa-code",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973780/cursor_ym5ik1.jpg",
        "dateAdded": 1677801600000,
        "tags": [
          "cursor",
          "ai coding assistants",
          "freemium",
          "aifirst",
          "code",
          "editor",
          "pairprogramming"
        ],
        "rating": 4.1,
        "reviewCount": "186+"
      },
      {
        "name": "GitHub Copilot",
        "pricing": "Free",
        "description": "AI pair programmer that offers autocomplete-style suggestions as you code.",
        "url": "https://copilot.github.com",
        "icon": "fab fa-github",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983252/github_nkfknt.jpg",
        "dateAdded": 1677888000000,
        "tags": [
          "github copilot",
          "ai coding assistants",
          "free",
          "github",
          "copilot",
          "pair",
          "programmer",
          "autocompletestyle",
          "suggestions",
          "you",
          "code"
        ],
        "rating": 4.6,
        "reviewCount": "5,600+"
      },
      {
        "name": "Qodo",
        "pricing": "Freemium",
        "description": "AI assistant to help write SQL, regex, and other code snippets.",
        "url": "https://www.qodo.ai/",
        "icon": "fas fa-code",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989071/qodo_ljykmk.jpg",
        "dateAdded": 1678233600000,
        "tags": [
          "qodo",
          "ai coding assistants",
          "freemium",
          "assistant",
          "write",
          "sql",
          "regex",
          "code",
          "snippets"
        ],
        "rating": 4.8,
        "reviewCount": "349+"
      },
      {
        "name": "Replit",
        "pricing": "Freemium",
        "description": "An online IDE with an AI coding assistant for building, testing, and deploying.",
        "url": "https://replit.com",
        "icon": "fas fa-code",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989173/replit_rpauh1.jpg",
        "dateAdded": 1678320000000,
        "tags": [
          "replit",
          "ai coding assistants",
          "freemium",
          "ide",
          "coding",
          "assistant",
          "building",
          "testing",
          "deploying"
        ],
        "rating": 4.4,
        "reviewCount": "314+"
      },
      {
        "name": "Tabnine",
        "pricing": "Freemium",
        "description": "AI assistant for software developers to code faster with whole-line and full-function code completions.",
        "url": "https://www.tabnine.com",
        "icon": "fas fa-code",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990558/tabnine_z2kowm.jpg",
        "dateAdded": 1678665600000,
        "tags": [
          "tabnine",
          "ai coding assistants",
          "freemium",
          "assistant",
          "developers",
          "code",
          "faster",
          "wholeline",
          "fullfunction",
          "completions"
        ],
        "rating": 4.7,
        "reviewCount": "473+"
      },
      {
        "name": "windsurf AI",
        "pricing": "Free",
        "description": "AI-powered code generation and assistance tool for developers.",
        "url": "https://windsurf.com/",
        "icon": "fas fa-code",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991402/windsurf_mcz33t.jpg",
        "dateAdded": 1678665600000,
        "tags": [
          "windsurf ai",
          "ai coding assistants",
          "free",
          "windsurf",
          "aipowered",
          "code",
          "generation",
          "assistance",
          "developers"
        ],
        "rating": 4,
        "reviewCount": "326+"
      }
    ]
  },
  {
    "id": "faceless-video",
    "name": "Faceless AI Video Tools",
    "tools": [
      {
        "name": "Syllaby",
        "pricing": "Freemium",
        "description": "Generate viral content ideas, turn into scripts, create AI clone, AI talking avatar, and post to social media.",
        "url": "https://syllaby.io",
        "icon": "fas fa-video",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989478/syllaby_rdsid3.jpg",
        "dateAdded": 1761955200000,
        "tags": [
          "syllaby",
          "faceless ai video",
          "freemium",
          "viral",
          "content",
          "ideas",
          "turn",
          "into",
          "scripts",
          "clone",
          "talking",
          "avatar",
          "post",
          "social",
          "media"
        ],
        "rating": 4.7,
        "reviewCount": "264+"
      },
      {
        "name": "vSUB",
        "pricing": "Freemium",
        "description": "Create Reddit stories, fake chats, Minecraft videos, quizzes, riddles.",
        "url": "https://vsub.io",
        "icon": "fas fa-video",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991328/vsub_pbnkxz.jpg",
        "dateAdded": 1761955200000,
        "tags": [
          "vsub",
          "faceless ai video",
          "freemium",
          "reddit",
          "stories",
          "fake",
          "chats",
          "minecraft",
          "videos",
          "quizzes",
          "riddles"
        ],
        "rating": 4.3,
        "reviewCount": "146+"
      },
      {
        "name": "opus.pro",
        "pricing": "Freemium",
        "description": "Create videos with AI avatars, text-to-video, text-to-speech, and more.",
        "url": "https://www.opus.pro/",
        "icon": "fas fa-video",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986807/opus_kvguhf.jpg",
        "dateAdded": 1761955200000,
        "tags": [
          "opus.pro",
          "faceless ai video",
          "freemium",
          "opuspro",
          "videos",
          "avatars",
          "texttovideo",
          "texttospeech"
        ],
        "rating": 4.8,
        "reviewCount": "263+"
      }
    ]
  },
  {
    "id": "email-assistance",
    "name": "AI Email Assistance",
    "tools": [
      {
        "name": "Clippit.ai",
        "pricing": "Freemium",
        "description": "Summarize long emails and attachments, and draft replies with AI.",
        "url": "https://clippit.ai/",
        "icon": "fas fa-paperclip",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973929/clippit_iqdtr0.jpg",
        "dateAdded": 1679011200000,
        "tags": [
          "clippit.ai",
          "ai email assistance",
          "freemium",
          "clippitai",
          "summarize",
          "emails",
          "attachments",
          "draft",
          "replies"
        ],
        "rating": 4.4,
        "reviewCount": "35+"
      },
      {
        "name": "Friday",
        "pricing": "Freemium",
        "description": "An AI assistant that helps you write better emails faster, right inside your inbox.",
        "url": "https://www.friday.ai/",
        "icon": "fas fa-calendar-day",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976511/friday_vavuvd.jpg",
        "dateAdded": 1679184000000,
        "tags": [
          "friday",
          "ai email assistance",
          "freemium",
          "assistant",
          "helps",
          "you",
          "write",
          "emails",
          "faster",
          "right",
          "inside",
          "your",
          "inbox"
        ],
        "rating": 4.8,
        "reviewCount": "32+"
      },
      {
        "name": "Mailmaestro",
        "pricing": "Freemium",
        "description": "AI email assistant for Outlook that helps you write emails 10x faster.",
        "url": "https://www.maestrolabs.com/",
        "icon": "fas fa-hat-wizard",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985975/MaestroLabs_fnphtv.jpg",
        "dateAdded": 1679270400000,
        "tags": [
          "mailmaestro",
          "ai email assistance",
          "freemium",
          "email",
          "assistant",
          "outlook",
          "helps",
          "you",
          "write",
          "emails",
          "10x",
          "faster"
        ],
        "rating": 4.6,
        "reviewCount": "234+"
      },
      {
        "name": "Shortwave",
        "pricing": "Freemium",
        "description": "An intelligent email client that organizes your inbox and helps you write with AI.",
        "url": "https://www.shortwave.com/",
        "icon": "fas fa-wave-square",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989551/shortwave_jfhxk9.jpg",
        "dateAdded": 1679529600000,
        "tags": [
          "shortwave",
          "ai email assistance",
          "freemium",
          "email",
          "client",
          "organizes",
          "your",
          "inbox",
          "helps",
          "you",
          "write"
        ],
        "rating": 4.1,
        "reviewCount": "297+"
      },
      {
        "name": "Superhuman",
        "pricing": "Paid",
        "description": "AI-powered email client that helps you manage your inbox efficiently.",
        "icon": "fas fa-envelope",
        "url": "https://superhuman.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989471/superhuman_ygupup.jpg",
        "dateAdded": 1679788800000,
        "tags": [
          "superhuman",
          "ai email assistance",
          "paid",
          "aipowered",
          "email",
          "client",
          "helps",
          "you",
          "manage",
          "your",
          "inbox",
          "efficiently"
        ],
        "rating": 4.8,
        "reviewCount": "37+"
      },
      {
        "name": "Lightfield",
        "pricing": "subscription",
        "description": "Lightfield is a next-generation CRM that self-assembles and automates your customer interactions.",
        "url": "https://lightfield.app/",
        "icon": "fas fa-database",
        "isNew": false,
        "comingSoon": false,
        "badge": "Featured",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985195/lightfield_j4ddmh.jpg",
        "dateAdded": 1763942400000,
        "tags": [
          "lightfield",
          "ai email assistance",
          "subscription",
          "nextgeneration",
          "crm",
          "selfassembles",
          "automates",
          "your",
          "customer",
          "interactions"
        ],
        "rating": 4,
        "reviewCount": "334+"
      }
    ]
  },
  {
    "id": "spreadsheet-tools",
    "name": "AI Spreadsheet Tools",
    "tools": [
      {
        "name": "Bricks",
        "pricing": "Freemium",
        "description": "Build interactive workflows and apps directly from your spreadsheets with AI.",
        "url": "https://bricks.ai/",
        "icon": "fas fa-cubes",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972953/bricks_ejhqor.jpg",
        "dateAdded": 1679788800000,
        "tags": [
          "bricks",
          "ai spreadsheet",
          "freemium",
          "build",
          "interactive",
          "workflows",
          "apps",
          "directly",
          "your",
          "spreadsheets"
        ],
        "rating": 4.6,
        "reviewCount": "192+"
      },
      {
        "name": "Formula Bot",
        "pricing": "Freemium",
        "description": "Generate spreadsheet formulas from text instructions for Excel and Google Sheets.",
        "url": "https://formulabot.com/",
        "icon": "fas fa-robot",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976510/formulabot_aleqja.jpg",
        "dateAdded": 1680134400000,
        "tags": [
          "formula bot",
          "ai spreadsheet",
          "freemium",
          "formula",
          "bot",
          "spreadsheet",
          "formulas",
          "text",
          "instructions",
          "excel",
          "google",
          "sheets"
        ],
        "rating": 4.1,
        "reviewCount": "219+"
      },
      {
        "name": "Gigasheet",
        "pricing": "Freemium",
        "description": "Analyze billions of rows in spreadsheets with no-code AI data analysis.",
        "url": "https://www.gigasheet.com/",
        "icon": "fas fa-table",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983249/gigasheet_wus4qg.jpg",
        "dateAdded": 1680220800000,
        "tags": [
          "gigasheet",
          "ai spreadsheet",
          "freemium",
          "analyze",
          "billions",
          "rows",
          "spreadsheets",
          "nocode",
          "data",
          "analysis"
        ],
        "rating": 4.2,
        "reviewCount": "426+"
      },
      {
        "name": "Rows",
        "pricing": "Freemium",
        "description": "A modern spreadsheet with AI capabilities to analyze data and build reports.",
        "url": "https://rows.com/",
        "icon": "fas fa-stream",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989185/rows_nwsaeb.jpg",
        "dateAdded": 1680307200000,
        "tags": [
          "rows",
          "ai spreadsheet",
          "freemium",
          "modern",
          "spreadsheet",
          "capabilities",
          "analyze",
          "data",
          "build",
          "reports"
        ],
        "rating": 4.8,
        "reviewCount": "22+"
      },
      {
        "name": "SheetsAI",
        "pricing": "Freemium",
        "description": "An AI-powered add-on for Google Sheets to automate tasks and generate formulas.",
        "url": "https://www.sheetai.app/",
        "icon": "fas fa-google-drive",
        "isNew": false,
        "comingSoon": false,
        "badge": "Not Free",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989515/sheetai_sutbcb.jpg",
        "dateAdded": 1680480000000,
        "tags": [
          "sheetsai",
          "ai spreadsheet",
          "freemium",
          "aipowered",
          "addon",
          "google",
          "sheets",
          "automate",
          "tasks",
          "formulas"
        ],
        "rating": 4,
        "reviewCount": "281+"
      }
    ]
  },
  {
    "id": "meeting-notes",
    "name": "AI Meeting Notes",
    "tools": [
      {
        "name": "Avoma",
        "pricing": "Freemium",
        "description": "An AI meeting assistant that provides transcription, summaries, and insights.",
        "url": "https://www.avoma.com/",
        "icon": "fas fa-comments",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972205/Avoma_cnmv0w.jpg",
        "dateAdded": 1680566400000,
        "tags": [
          "avoma",
          "ai meeting notes",
          "freemium",
          "meeting",
          "assistant",
          "transcription",
          "summaries",
          "insights"
        ],
        "rating": 4.6,
        "reviewCount": "345+"
      },
      {
        "name": "Equal Time",
        "pricing": "Freemium",
        "description": "AI tool to ensure inclusive meetings by tracking speaking time and providing feedback.",
        "url": "https://www.equaltime.io/",
        "icon": "fas fa-balance-scale",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976453/EqualTime_podawk.jpg",
        "dateAdded": 1680652800000,
        "tags": [
          "equal time",
          "ai meeting notes",
          "freemium",
          "equal",
          "ensure",
          "inclusive",
          "meetings",
          "tracking",
          "speaking",
          "providing",
          "feedback"
        ],
        "rating": 4.2,
        "reviewCount": "211+"
      },
      {
        "name": "Fathom",
        "pricing": "Freemium",
        "description": "An AI meeting assistant that records, transcribes, and summarizes your Zoom calls.",
        "url": "https://fathom.video/",
        "icon": "fas fa-video",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976585/Fathom_tzg23o.jpg",
        "dateAdded": 1680739200000,
        "tags": [
          "fathom",
          "ai meeting notes",
          "freemium",
          "meeting",
          "assistant",
          "records",
          "transcribes",
          "summarizes",
          "your",
          "zoom",
          "calls"
        ],
        "rating": 4.5,
        "reviewCount": "15+"
      },
      {
        "name": "Fellow.app",
        "pricing": "Freemium",
        "description": "A meeting management tool with AI features for agendas, notes, and action items.",
        "url": "https://fellow.app/",
        "icon": "fas fa-users",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976464/Fellow_bjanzc.jpg",
        "dateAdded": 1680825600000,
        "tags": [
          "fellow.app",
          "ai meeting notes",
          "freemium",
          "fellowapp",
          "meeting",
          "management",
          "agendas",
          "notes",
          "action",
          "items"
        ],
        "rating": 4.3,
        "reviewCount": "409+"
      },
      {
        "name": "Krisp",
        "pricing": "Freemium",
        "description": "AI-powered noise cancellation and voice clarity for more effective online meetings.",
        "url": "https://krisp.ai/",
        "icon": "fas fa-microphone-slash",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984767/Krisp_uwduqe.jpg",
        "dateAdded": 1681171200000,
        "tags": [
          "krisp",
          "ai meeting notes",
          "freemium",
          "aipowered",
          "noise",
          "cancellation",
          "voice",
          "clarity",
          "effective",
          "meetings"
        ],
        "rating": 4.6,
        "reviewCount": "35+"
      },
      {
        "name": "Fireflies",
        "pricing": "Freemium",
        "description": "AI meeting assistant that records, transcribes, and analyzes meetings.",
        "icon": "fas fa-video",
        "url": "https://fireflies.ai/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976479/fireflies_temsvo.jpg",
        "dateAdded": 1681171200000,
        "tags": [
          "fireflies",
          "ai meeting notes",
          "freemium",
          "meeting",
          "assistant",
          "records",
          "transcribes",
          "analyzes",
          "meetings"
        ],
        "rating": 4.3,
        "reviewCount": "424+"
      },
      {
        "name": "Otter.ai",
        "pricing": "Freemium",
        "description": "AI transcription tool for meetings and conversations with real-time note-taking and summaries.",
        "icon": "fas fa-microphone-alt",
        "url": "https://otter.ai/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986798/Otter_viu1vu.jpg",
        "dateAdded": 1681257600000,
        "tags": [
          "otter.ai",
          "ai meeting notes",
          "freemium",
          "otterai",
          "transcription",
          "meetings",
          "conversations",
          "realtime",
          "notetaking",
          "summaries"
        ],
        "rating": 4.6,
        "reviewCount": "1,100+"
      },
      {
        "name": "Granola",
        "pricing": "Freemium",
        "description": "AI-powered meeting recorder and note-taker that works in the background, AI notetaker",
        "icon": "fas fa-microphone-alt",
        "url": "https://granola.so/",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983176/Granola_us9xjb.jpg",
        "dateAdded": 1685664000000,
        "tags": [
          "granola",
          "ai meeting notes",
          "freemium",
          "aipowered",
          "meeting",
          "recorder",
          "notetaker",
          "works",
          "background"
        ],
        "rating": 4.3,
        "reviewCount": "313+"
      }
    ]
  },
  {
    "id": "writing-tools",
    "name": "AI Writing Tools",
    "tools": [
      {
        "name": "Rytr",
        "pricing": "Freemium",
        "description": "AI writing assistant to create high-quality content in seconds.",
        "url": "https://rytr.me",
        "icon": "fas fa-pen",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989151/Rytr_phdxvj.jpg",
        "dateAdded": 1681344000000,
        "tags": [
          "rytr",
          "ai writing",
          "freemium",
          "writing",
          "assistant",
          "highquality",
          "content",
          "seconds"
        ],
        "rating": 4.7,
        "reviewCount": "274+"
      },
      {
        "name": "WriteSonic",
        "pricing": "Freemium",
        "description": "Best AI tool for writing blog posts, essays, copy, emails.",
        "url": "https://writesonic.com",
        "icon": "fas fa-pen",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991420/writesonic_cyxxgj.jpg",
        "dateAdded": 1681516800000,
        "tags": [
          "writesonic",
          "ai writing",
          "freemium",
          "writing",
          "blog",
          "posts",
          "essays",
          "copy",
          "emails"
        ],
        "rating": 4.2,
        "reviewCount": "290+"
      },
      {
        "name": "Copy AI",
        "pricing": "Freemium",
        "description": "All-in-one AI tool for marketing and content creation.",
        "url": "https://www.copy.ai",
        "icon": "fas fa-pen",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973961/Copy_kvyb2e.jpg",
        "dateAdded": 1681689600000,
        "tags": [
          "copy ai",
          "ai writing",
          "freemium",
          "copy",
          "allinone",
          "marketing",
          "content",
          "creation"
        ],
        "rating": 4.1,
        "reviewCount": "95+"
      },
      {
        "name": "Beehiiv",
        "pricing": "Freemium",
        "description": "Monetize your newsletter and grow subscribers.",
        "url": "https://www.beehiiv.com",
        "icon": "fas fa-pen",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972964/Beehiiv_hyrzvn.jpg",
        "dateAdded": 1681862400000,
        "tags": [
          "beehiiv",
          "ai writing",
          "freemium",
          "monetize",
          "your",
          "newsletter",
          "grow",
          "subscribers"
        ],
        "rating": 4.8,
        "reviewCount": "120+"
      },
      {
        "name": "Undetectable AI",
        "pricing": "Freemium",
        "description": "AI Detector and Humanizer for converting AI text to human tone.",
        "url": "https://undetectable.ai",
        "icon": "fas fa-pen",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991220/Undetectable_f7tunt.jpg",
        "dateAdded": 1682380800000,
        "tags": [
          "undetectable ai",
          "ai writing",
          "freemium",
          "undetectable",
          "detector",
          "humanizer",
          "converting",
          "text",
          "human",
          "tone"
        ],
        "rating": 4.7,
        "reviewCount": "330+"
      },
      {
        "name": "Life Shack Inc",
        "pricing": "Freemium",
        "description": "Job finder with AI resume tailoring and applications.",
        "url": "https://www.lifeshack.io",
        "icon": "fas fa-briefcase",
        "isNew": false,
        "comingSoon": false,
        "badge": "New!",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985171/lifeshack_asvizq.jpg",
        "dateAdded": 1682467200000,
        "tags": [
          "life shack inc",
          "ai writing",
          "freemium",
          "life",
          "shack",
          "inc",
          "job",
          "finder",
          "resume",
          "tailoring",
          "applications"
        ],
        "rating": 4.4,
        "reviewCount": "422+"
      },
      {
        "name": "Ranked AI",
        "pricing": "Paid",
        "description": "Best SEO tool, weekly blog content, optimization, backlinks, and leading SEO software.",
        "url": "https://ranked.ai",
        "icon": "fas fa-pen",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989157/Ranked_fq35xb.jpg",
        "dateAdded": 1682467200000,
        "tags": [
          "ranked ai",
          "ai writing",
          "paid",
          "ranked",
          "seo",
          "weekly",
          "blog",
          "content",
          "optimization",
          "backlinks",
          "leading"
        ],
        "rating": 4.4,
        "reviewCount": "411+"
      },
      {
        "name": "Jasper AI",
        "pricing": "Paid",
        "description": "Copywriting tool PRO for content and marketing.",
        "url": "https://jasper.ai",
        "icon": "fas fa-pen",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984401/Jasper_dywcp0.jpg",
        "dateAdded": 1682726400000,
        "tags": [
          "jasper ai",
          "ai writing",
          "paid",
          "jasper",
          "copywriting",
          "pro",
          "content",
          "marketing"
        ],
        "rating": 4.6,
        "reviewCount": "4,100+"
      },
      {
        "name": "Tango",
        "pricing": "Freemium",
        "description": "Automatically documents processes with screenshots and instructions.",
        "url": "https://www.tango.us",
        "icon": "fas fa-pen",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990423/Tango_wsbfhn.jpg",
        "dateAdded": 1682985600000,
        "tags": [
          "tango",
          "ai writing",
          "freemium",
          "documents",
          "processes",
          "screenshots",
          "instructions"
        ],
        "rating": 4.6,
        "reviewCount": "338+"
      },
      {
        "name": "Tldv",
        "pricing": "Freemium",
        "description": "Transcribes and summarizes meetings with AI.",
        "url": "https://www.tldv.io",
        "icon": "fas fa-pen",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990468/tldv_jd95qo.jpg",
        "dateAdded": 1683244800000,
        "tags": [
          "tldv",
          "ai writing",
          "freemium",
          "transcribes",
          "summarizes",
          "meetings"
        ],
        "rating": 4.7,
        "reviewCount": "507+"
      },
      {
        "name": "Blaze AI",
        "pricing": "Freemium",
        "description": "Generate content briefs, ads, and social posts with your brand voice.",
        "url": "https://www.blaze.ai",
        "icon": "fas fa-pen",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972952/Blaze_mnqyvy.jpg",
        "dateAdded": 1683331200000,
        "tags": [
          "blaze ai",
          "ai writing",
          "freemium",
          "blaze",
          "content",
          "briefs",
          "ads",
          "social",
          "posts",
          "your",
          "brand",
          "voice"
        ],
        "rating": 4.2,
        "reviewCount": "357+"
      },
      {
        "name": "Aithor",
        "pricing": "Freemium",
        "description": " Ai eassy writter.",
        "url": "https://aithor.com",
        "icon": "fas fa-pen",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972180/Aithor_t2wka3.jpg",
        "dateAdded": 1683849600000,
        "tags": [
          "aithor",
          "ai writing",
          "freemium",
          "eassy",
          "writter"
        ],
        "rating": 4.7,
        "reviewCount": "484+"
      },
      {
        "name": "AdCreative.ai",
        "pricing": "Freemium",
        "description": "AI-powered platform that generates high-converting ad creatives, texts, and social media posts for marketers and businesses.",
        "icon": "fas fa-bullhorn",
        "url": "https://www.adcreative.ai/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972179/adcreative_hpx8dj.jpg",
        "dateAdded": 1683849600000,
        "tags": [
          "adcreative.ai",
          "ai writing",
          "freemium",
          "adcreativeai",
          "aipowered",
          "generates",
          "highconverting",
          "creatives",
          "texts",
          "social",
          "media",
          "posts",
          "marketers",
          "businesses"
        ],
        "rating": 4.8,
        "reviewCount": "54+"
      },
      {
        "name": "Grammarly",
        "pricing": "Freemium",
        "description": "AI writing assistant for checking grammar, spelling, clarity, and tone.",
        "url": "https://www.grammarly.com",
        "icon": "fas fa-pen-nib",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983264/Grammarly_cssvmc.jpg",
        "dateAdded": 1684022400000,
        "tags": [
          "grammarly",
          "ai writing",
          "freemium",
          "writing",
          "assistant",
          "checking",
          "grammar",
          "spelling",
          "clarity",
          "tone"
        ],
        "rating": 4.7,
        "reviewCount": "20,000+"
      },
      {
        "name": "JotBot",
        "pricing": "Freemium",
        "description": "An AI writing assistant designed for students to help with essays and assignments.",
        "url": "https://myjotbot.com/",
        "icon": "fas fa-pen-nib",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984407/JotBot_b4gabe.jpg",
        "dateAdded": 1684108800000,
        "tags": [
          "jotbot",
          "ai writing",
          "freemium",
          "writing",
          "assistant",
          "students",
          "essays",
          "assignments"
        ],
        "rating": 4.4,
        "reviewCount": "164+"
      },
      {
        "name": "Quarkle",
        "pricing": "Freemium",
        "description": "AI tool to summarize long articles, documents, and videos into key points.",
        "url": "https://www.quarkle.ai",
        "icon": "fas fa-pen-nib",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989075/Quarkle_ooxwfs.jpg",
        "dateAdded": 1684281600000,
        "tags": [
          "quarkle",
          "ai writing",
          "freemium",
          "summarize",
          "articles",
          "documents",
          "videos",
          "into",
          "key",
          "points"
        ],
        "rating": 4.6,
        "reviewCount": "16+"
      }
    ]
  },
  {
    "id": "video-generators",
    "name": "AI Video Generators",
    "tools": [
      {
        "name": "Kling",
        "pricing": "Freemium",
        "description": "Create AI videos from text, images, motion brush, animated videos.",
        "url": "https://www.klingai.com/global",
        "icon": "fas fa-video",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984744/KlingAI_adqhvt.jpg",
        "dateAdded": 1684972800000,
        "tags": [
          "kling",
          "ai video generators",
          "freemium",
          "videos",
          "text",
          "images",
          "motion",
          "brush",
          "animated"
        ],
        "rating": 4.1,
        "reviewCount": "225+"
      },
      {
        "name": "HauliiuAI",
        "pricing": "Freemium",
        "description": "Same as Kling but lets you add your character into the video.",
        "url": "https://hailuoai.video",
        "icon": "fas fa-video",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983999/HailuoAI_ktonxt.jpg",
        "dateAdded": 1685318400000,
        "tags": [
          "hauliiuai",
          "ai video generators",
          "freemium",
          "same",
          "kling",
          "lets",
          "you",
          "add",
          "your",
          "character",
          "into",
          "video"
        ],
        "rating": 4.7,
        "reviewCount": "257+"
      },
      {
        "name": "Submagic",
        "pricing": "Freemium",
        "description": "Create viral shorts with captions, B-Rolls, zooms, sound effects.",
        "url": "https://www.submagic.co",
        "icon": "fas fa-video",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989448/Submagic_ubroo9.jpg",
        "dateAdded": 1685318400000,
        "tags": [
          "submagic",
          "ai video generators",
          "freemium",
          "viral",
          "shorts",
          "captions",
          "brolls",
          "zooms",
          "sound",
          "effects"
        ],
        "rating": 4.9,
        "reviewCount": "138+"
      },
      {
        "name": "HeyGen",
        "pricing": "Freemium",
        "description": "Studio-quality videos, face cloning, translations.",
        "url": "https://www.heygen.com",
        "icon": "fas fa-video",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984004/Heygen_cbo6s7.jpg",
        "dateAdded": 1685750400000,
        "tags": [
          "heygen",
          "ai video generators",
          "freemium",
          "studioquality",
          "videos",
          "face",
          "cloning",
          "translations"
        ],
        "rating": 4.7,
        "reviewCount": "276+"
      },
      {
        "name": "Akool",
        "pricing": "Freemium",
        "description": "Face swap app to create realistic videos.",
        "url": "https://www.akool.com",
        "icon": "fas fa-video",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972180/Akool_qzalom.jpg",
        "dateAdded": 1685923200000,
        "tags": [
          "akool",
          "ai video generators",
          "freemium",
          "face",
          "swap",
          "realistic",
          "videos"
        ],
        "rating": 4.9,
        "reviewCount": "146+"
      },
      {
        "name": "VidAI",
        "pricing": "Freemium",
        "description": "Product videos from links/images, face swap, watermark removal.",
        "url": "https://vid.ai",
        "icon": "fas fa-video",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991261/Vid_qgxxco.jpg",
        "dateAdded": 1686268800000,
        "tags": [
          "vidai",
          "ai video generators",
          "freemium",
          "product",
          "videos",
          "linksimages",
          "face",
          "swap",
          "watermark",
          "removal"
        ],
        "rating": 4.7,
        "reviewCount": "77+"
      },
      {
        "name": "Vozo",
        "pricing": "Freemium",
        "description": "Create, dub, lip sync, translate talking videos with AI.",
        "url": "https://www.vozo.ai",
        "icon": "fas fa-video",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991302/vozo_mrdebg.jpg",
        "dateAdded": 1686355200000,
        "tags": [
          "vozo",
          "ai video generators",
          "freemium",
          "dub",
          "lip",
          "sync",
          "translate",
          "talking",
          "videos"
        ],
        "rating": 4.6,
        "reviewCount": "327+"
      },
      {
        "name": "Kreado AI",
        "pricing": "Freemium",
        "description": "Studio-quality AI avatar videos.",
        "url": "https://www.kreadoai.com",
        "icon": "fas fa-video",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984761/KreadoAI_vlbsi2.jpg",
        "dateAdded": 1686528000000,
        "tags": [
          "kreado ai",
          "ai video generators",
          "freemium",
          "kreado",
          "studioquality",
          "avatar",
          "videos"
        ],
        "rating": 4.7,
        "reviewCount": "35+"
      },
      {
        "name": "DeepBrain",
        "pricing": "Freemium",
        "description": "Text to video with AI avatars.",
        "url": "https://www.deepbrain.io",
        "icon": "fas fa-video",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983062/DeepBrain_nq7otl.jpg",
        "dateAdded": 1686528000000,
        "tags": [
          "deepbrain",
          "ai video generators",
          "freemium",
          "text",
          "video",
          "avatars"
        ],
        "rating": 4.5,
        "reviewCount": "14+"
      },
      {
        "name": "Crayo",
        "pricing": "Freemium",
        "description": "AI-generated music.",
        "url": "https://www.crayo.ai",
        "icon": "fas fa-music",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972964/Beehiiv_hyrzvn.jpg",
        "dateAdded": 1686700800000,
        "tags": [
          "crayo",
          "ai video generators",
          "freemium",
          "aigenerated",
          "music"
        ],
        "rating": 4.5,
        "reviewCount": "125+"
      },
      {
        "name": "Pictory AI",
        "pricing": "Freemium",
        "description": "Easy video creation for content marketers.",
        "url": "https://pictory.ai",
        "icon": "fas fa-video",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763987409/Pictory_b3gb40.jpg",
        "dateAdded": 1686873600000,
        "tags": [
          "pictory ai",
          "ai video generators",
          "freemium",
          "pictory",
          "video",
          "creation",
          "content",
          "marketers"
        ],
        "rating": 4.4,
        "reviewCount": "209+"
      },
      {
        "name": "Fliki AI",
        "pricing": "Freemium",
        "description": "Convert text to videos with AI voices.",
        "url": "https://fliki.ai",
        "icon": "fas fa-video",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976481/fliki_eewygo.jpg",
        "dateAdded": 1687046400000,
        "tags": [
          "fliki ai",
          "ai video generators",
          "freemium",
          "fliki",
          "convert",
          "text",
          "videos",
          "voices"
        ],
        "rating": 4.5,
        "reviewCount": "166+"
      },
      {
        "name": "Latte",
        "pricing": "Freemium",
        "description": "Clip short-form content from long videos in a click.",
        "url": "https://www.latte.social/",
        "icon": "fas fa-video",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985138/latte_ukf5gt.jpg",
        "dateAdded": 1687132800000,
        "tags": [
          "latte",
          "ai video generators",
          "freemium",
          "clip",
          "shortform",
          "content",
          "videos",
          "click"
        ],
        "rating": 4.4,
        "reviewCount": "41+"
      },
      {
        "name": "Zencoder",
        "pricing": "Freemium",
        "description": "Cloud-based video transcoding service to convert videos into multiple formats for web, mobile, and TV playback.",
        "url": "https://zencoder.com/",
        "icon": "fas fa-cloud-upload-alt",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991530/zencoder_g9r7gg.jpg",
        "dateAdded": 1687478400000,
        "tags": [
          "zencoder",
          "ai video generators",
          "freemium",
          "cloudbased",
          "video",
          "transcoding",
          "convert",
          "videos",
          "into",
          "multiple",
          "formats",
          "web",
          "mobile",
          "playback"
        ],
        "rating": 4,
        "reviewCount": "409+"
      },
      {
        "name": "Descript",
        "pricing": "Freemium",
        "description": "An all-in-one AI-powered audio and video editor for easy transcription, editing, and collaboration.",
        "url": "https://www.descript.com/",
        "icon": "fas fa-microphone-alt",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763975504/descript_wfuas8.jpg",
        "dateAdded": 1687737600000,
        "tags": [
          "descript",
          "ai video generators",
          "freemium",
          "allinone",
          "aipowered",
          "audio",
          "video",
          "editor",
          "transcription",
          "editing",
          "collaboration"
        ],
        "rating": 4.3,
        "reviewCount": "493+"
      },
      {
        "name": "Imagine art",
        "pricing": "Freemium",
        "description": "Create stunning AI-generated art from your imagination. Transform words into breathtaking visuals using cutting-edge generative models.",
        "url": "https://www.imagine.art",
        "icon": "fas fa-palette",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984225/imagineart_n9uy4t.jpg",
        "dateAdded": 1695168000000,
        "tags": [
          "imagine art",
          "ai video generators",
          "freemium",
          "imagine",
          "art",
          "stunning",
          "aigenerated",
          "your",
          "imagination",
          "transform",
          "words",
          "into",
          "breathtaking",
          "visuals",
          "cuttingedge"
        ],
        "rating": 4.1,
        "reviewCount": "201+"
      },
      {
        "name": "Krea AI",
        "pricing": "Freemium",
        "description": "A real-time AI tool for generating and enhancing images and videos with creative control.",
        "url": "https://www.krea.ai/",
        "icon": "fas fa-magic",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984755/krea_n0ue6z.jpg",
        "dateAdded": 1687996800000,
        "tags": [
          "krea ai",
          "ai video generators",
          "freemium",
          "krea",
          "realtime",
          "generating",
          "enhancing",
          "images",
          "videos",
          "creative",
          "control"
        ],
        "rating": 4.3,
        "reviewCount": "193+"
      },
      {
        "name": "LTX Studio",
        "pricing": "Freemium",
        "description": "An AI-driven platform that turns ideas and text into complete video productions with storyboarding and editing.",
        "url": "https://ltx.studio/",
        "icon": "fas fa-clapperboard",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985230/ltx_p5eogk.jpg",
        "dateAdded": 1688428800000,
        "tags": [
          "ltx studio",
          "ai video generators",
          "freemium",
          "ltx",
          "studio",
          "aidriven",
          "turns",
          "ideas",
          "text",
          "into",
          "complete",
          "video",
          "productions",
          "storyboarding",
          "editing"
        ],
        "rating": 4.1,
        "reviewCount": "177+"
      },
      {
        "name": "Luma AI",
        "pricing": "Freemium",
        "description": "Create incredible lifelike 3D models and scenes from video using your phone or text prompts.",
        "url": "https://lumalabs.ai/",
        "icon": "fas fa-cube",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985237/lumalabs_vbvqdl.jpg",
        "dateAdded": 1688515200000,
        "tags": [
          "luma ai",
          "ai video generators",
          "freemium",
          "luma",
          "incredible",
          "lifelike",
          "scenes",
          "video",
          "your",
          "phone",
          "text",
          "prompts"
        ],
        "rating": 4.6,
        "reviewCount": "156+"
      },
      {
        "name": "Pika AI",
        "pricing": "Freemium",
        "description": "An idea-to-video platform that brings your creativity to life with generative AI video.",
        "url": "https://pika.art/",
        "icon": "fas fa-play-circle",
        "isNew": false,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763988715/pika_ezeo6y.jpg",
        "dateAdded": 1690502400000,
        "tags": [
          "pika ai",
          "ai video generators",
          "freemium",
          "pika",
          "ideatovideo",
          "brings",
          "your",
          "creativity",
          "life",
          "generative",
          "video"
        ],
        "rating": 4.1,
        "reviewCount": "87+"
      },
      {
        "name": "Sora",
        "pricing": "Freemium",
        "description": "OpenAI's text-to-video model that can create realistic and imaginative scenes from text instructions.",
        "url": "https://sora.chatgpt.com/explore",
        "icon": "fas fa-robot",
        "isNew": false,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1766651726/sora_kjc0q7.jpg",
        "dateAdded": 1690761600000,
        "tags": [
          "sora",
          "ai video generators",
          "freemium",
          "openais",
          "texttovideo",
          "realistic",
          "imaginative",
          "scenes",
          "text",
          "instructions"
        ],
        "rating": 4.5,
        "reviewCount": "127+"
      },
      {
        "name": "Argil",
        "pricing": "Freemium",
        "description": "Create UGC ads and promotional content using realistic AI avatars.",
        "url": "https://www.argil.ai",
        "icon": "fas fa-pen",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972180/Argil_w1qh1v.jpg",
        "dateAdded": 1682467200000,
        "tags": [
          "argil",
          "ai video generators",
          "freemium",
          "ugc",
          "ads",
          "promotional",
          "content",
          "realistic",
          "avatars"
        ],
        "rating": 4.3,
        "reviewCount": "141+"
      }
    ]
  },
  {
    "id": "presentation-tools",
    "name": "AI Presentation Tools",
    "tools": [
      {
        "name": "Gamma AI",
        "pricing": "Freemium",
        "description": "Make customizable presentations and web pages in minutes.",
        "url": "https://gamma.app",
        "icon": "fas fa-chalkboard-teacher",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983235/gamma_wa7c5f.jpg",
        "dateAdded": 1691539200000,
        "tags": [
          "gamma ai",
          "ai presentation",
          "freemium",
          "gamma",
          "customizable",
          "presentations",
          "web",
          "pages",
          "minutes"
        ],
        "rating": 4.7,
        "reviewCount": "358+"
      },
      {
        "name": "Decktopus",
        "pricing": "Freemium",
        "description": "AI-powered presentation maker that helps you create professional presentations in minutes.",
        "url": "https://www.decktopus.com",
        "icon": "fas fa-chalkboard-teacher",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763975496/decktopus_rmnnxc.jpg",
        "dateAdded": 1692316800000,
        "tags": [
          "decktopus",
          "ai presentation",
          "freemium",
          "aipowered",
          "presentation",
          "maker",
          "helps",
          "you",
          "professional",
          "presentations",
          "minutes"
        ],
        "rating": 4.1,
        "reviewCount": "330+"
      },
      {
        "name": "Beautiful.ai",
        "pricing": "Freemium",
        "description": "Smart presentation maker that helps you create stunning, clean, and modern slides with AI-assisted design.",
        "url": "https://www.beautiful.ai",
        "icon": "fas fa-chalkboard-teacher",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972964/beautifulai_jc7afk.jpg",
        "dateAdded": 1692403200000,
        "tags": [
          "beautiful.ai",
          "ai presentation",
          "freemium",
          "beautifulai",
          "presentation",
          "maker",
          "helps",
          "you",
          "stunning",
          "clean",
          "modern",
          "slides",
          "aiassisted",
          "design"
        ],
        "rating": 4.7,
        "reviewCount": "475+"
      },
      {
        "name": "Slidesgo",
        "pricing": "Freemium",
        "description": "Free Google Slides and PowerPoint templates for presentations.",
        "url": "https://slidesgo.com",
        "icon": "fas fa-chalkboard-teacher",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989585/slidesgo_dgfq1p.jpg",
        "dateAdded": 1692576000000,
        "tags": [
          "slidesgo",
          "ai presentation",
          "freemium",
          "google",
          "slides",
          "powerpoint",
          "templates",
          "presentations"
        ],
        "rating": 4.6,
        "reviewCount": "260+"
      },
      {
        "name": "Visme",
        "pricing": "Freemium",
        "description": "Create presentations, infographics, and visual content with AI tools.",
        "url": "https://www.visme.co",
        "icon": "fas fa-chalkboard-teacher",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991266/visme_pogyki.jpg",
        "dateAdded": 1692921600000,
        "tags": [
          "visme",
          "ai presentation",
          "freemium",
          "presentations",
          "infographics",
          "visual",
          "content",
          "tools"
        ],
        "rating": 4.5,
        "reviewCount": "46+"
      },
      {
        "name": "SlidesAI",
        "pricing": "Freemium",
        "description": "AI tool that transforms text into professional-looking presentation slides automatically within seconds.",
        "url": "https://www.slidesai.io",
        "icon": "fas fa-chalkboard-teacher",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989578/slidesai_l7oppp.jpg",
        "dateAdded": 1693353600000,
        "tags": [
          "slidesai",
          "ai presentation",
          "freemium",
          "transforms",
          "text",
          "into",
          "professionallooking",
          "presentation",
          "slides",
          "within",
          "seconds"
        ],
        "rating": 4.5,
        "reviewCount": "60+"
      },
      {
        "name": "Pitch",
        "pricing": "Freemium",
        "description": "The collaborative presentation software for modern teams, enabling fast-moving teams to create and distribute beautiful presentations.",
        "url": "https://pitch.com",
        "icon": "fas fa-file-powerpoint",
        "isNew": false,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763987391/pitch_n6locw.jpg",
        "dateAdded": 1693872000000,
        "tags": [
          "pitch",
          "ai presentation",
          "freemium",
          "collaborative",
          "presentation",
          "modern",
          "teams",
          "enabling",
          "fastmoving",
          "distribute",
          "beautiful",
          "presentations"
        ],
        "rating": 4.1,
        "reviewCount": "84+"
      },
      {
        "name": "Plus AI",
        "pricing": "Freemium",
        "description": "An AI presentation maker for Google Slides. Create, edit, and format presentations in seconds.",
        "url": "https://www.plusdocs.com",
        "icon": "fas fa-magic",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763987443/plusai_q1tztj.jpg",
        "dateAdded": 1694217600000,
        "tags": [
          "plus ai",
          "ai presentation",
          "freemium",
          "plus",
          "presentation",
          "maker",
          "google",
          "slides",
          "edit",
          "format",
          "presentations",
          "seconds"
        ],
        "rating": 4,
        "reviewCount": "505+"
      },
      {
        "name": "Pop AI",
        "pricing": "Freemium",
        "description": "Your personal AI workspace. Chat with docs, create presentations, and generate images with a powerful AI assistant.",
        "url": "https://www.popai.pro",
        "icon": "fas fa-brain",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763988703/popai_tulo88.jpg",
        "dateAdded": 1694649600000,
        "tags": [
          "pop ai",
          "ai presentation",
          "freemium",
          "pop",
          "your",
          "personal",
          "workspace",
          "chat",
          "docs",
          "presentations",
          "images",
          "assistant"
        ],
        "rating": 4.8,
        "reviewCount": "157+"
      },
      {
        "name": "GenSpark AI",
        "pricing": "Freemium",
        "description": "An advanced AI platform that lets you generate content, code, and insights effortlessly — combining chat, image generation, and automation tools in one workspace.",
        "url": "https://www.genspark.ai",
        "icon": "fas fa-bolt",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983240/genspark_fpm8jq.jpg",
        "dateAdded": 1694995200000,
        "tags": [
          "genspark ai",
          "ai presentation",
          "freemium",
          "genspark",
          "lets",
          "you",
          "content",
          "code",
          "insights",
          "effortlessly",
          "combining",
          "chat",
          "image",
          "generation",
          "tools"
        ],
        "rating": 4.9,
        "reviewCount": "183+"
      }
    ]
  },
  {
    "id": "short-clippers",
    "name": "AI Long Video to Short Clipper",
    "tools": [
      {
        "name": "Klap App",
        "pricing": "Freemium",
        "description": "Turn videos into viral shorts with AI virality scoring.",
        "url": "https://www.klap.app",
        "icon": "fas fa-cut",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984743/klap_hopw3p.jpg",
        "dateAdded": 1694822400000,
        "tags": [
          "klap app",
          "ai long video to short clipper",
          "freemium",
          "klap",
          "turn",
          "videos",
          "into",
          "viral",
          "shorts",
          "virality",
          "scoring"
        ],
        "rating": 4.1,
        "reviewCount": "191+"
      },
      {
        "name": "Munch",
        "pricing": "Freemium",
        "description": "Top AI repurposing platform—clip long videos for all platforms.",
        "url": "https://www.getmunch.com",
        "icon": "fas fa-cut",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985830/munchstudio_ut5rsq.jpg",
        "dateAdded": 1694908800000,
        "tags": [
          "munch",
          "ai long video to short clipper",
          "freemium",
          "repurposing",
          "platformclip",
          "videos",
          "all",
          "platforms"
        ],
        "rating": 4.5,
        "reviewCount": "324+"
      },
      {
        "name": "Eightify",
        "pricing": "Freemium",
        "description": "AI tool that summarizes YouTube videos into key ideas using GPT technology.",
        "icon": "fas fa-video",
        "url": "https://eightify.app",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976434/Eightify_jnt3th.jpg",
        "dateAdded": 1696204800000,
        "tags": [
          "eightify",
          "ai long video to short clipper",
          "freemium",
          "summarizes",
          "youtube",
          "videos",
          "into",
          "key",
          "ideas",
          "gpt",
          "technology"
        ],
        "rating": 4.6,
        "reviewCount": "463+"
      },
      {
        "name": "Runway ML",
        "pricing": "Freemium",
        "description": "Next-gen AI video and image editing platform used for real-time content generation and special effects.",
        "icon": "fas fa-magic",
        "url": "https://runwayml.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989199/runway_ygl1zy.jpg",
        "dateAdded": 1696464000000,
        "tags": [
          "runway ml",
          "ai long video to short clipper",
          "freemium",
          "runway",
          "nextgen",
          "video",
          "image",
          "editing",
          "used",
          "realtime",
          "content",
          "generation",
          "special",
          "effects"
        ],
        "rating": 4.7,
        "reviewCount": "900+"
      },
      {
        "name": "ImgCreator",
        "pricing": "Freemium",
        "description": "AI image generator that creates realistic or stylized photos from text prompts.",
        "icon": "fas fa-image",
        "url": "https://www.zmo.ai/imgcreator",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991510/Zmo_gio2gk.jpg",
        "dateAdded": 1696809600000,
        "tags": [
          "imgcreator",
          "ai long video to short clipper",
          "freemium",
          "image",
          "generator",
          "creates",
          "realistic",
          "stylized",
          "photos",
          "text",
          "prompts"
        ],
        "rating": 4.7,
        "reviewCount": "372+"
      },
      {
        "name": "Morph Studio",
        "pricing": "Freemium",
        "description": "AI video generation platform that lets users create talking avatars and characters from text.",
        "icon": "fas fa-user-astronaut",
        "url": "https://www.morphstudio.com",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986059/morphstudio_nnstey.jpg",
        "dateAdded": 1696896000000,
        "tags": [
          "morph studio",
          "ai long video to short clipper",
          "freemium",
          "morph",
          "studio",
          "video",
          "generation",
          "lets",
          "talking",
          "avatars",
          "characters",
          "text"
        ],
        "rating": 4.7,
        "reviewCount": "318+"
      },
      {
        "name": "InVideo",
        "pricing": "Freemium",
        "description": "Online AI-powered video editor that helps you create engaging marketing, social, and promotional videos in minutes.",
        "icon": "fas fa-video",
        "url": "https://invideo.io",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984238/invideo_vvl3zf.jpg",
        "dateAdded": 1697155200000,
        "tags": [
          "invideo",
          "ai long video to short clipper",
          "freemium",
          "aipowered",
          "video",
          "editor",
          "helps",
          "you",
          "engaging",
          "marketing",
          "social",
          "promotional",
          "videos",
          "minutes"
        ],
        "rating": 4.7,
        "reviewCount": "35+"
      }
    ]
  },
  {
    "id": "marketing-tools",
    "name": "AI Marketing Tools",
    "tools": [
      {
        "name": "EasyGen",
        "pricing": "Freemium",
        "description": "Automate LinkedIn content, connect with top people, 10% off with code \"VAIBHAV\".",
        "url": "https://www.easygen.io",
        "icon": "fas fa-bullhorn",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976433/easygen_gmcvuv.jpg",
        "dateAdded": 1697760000000,
        "tags": [
          "easygen",
          "ai marketing",
          "freemium",
          "automate",
          "linkedin",
          "content",
          "connect",
          "people",
          "off",
          "code",
          "vaibhav"
        ],
        "rating": 4.7,
        "reviewCount": "484+"
      },
      {
        "name": "Contlo AI",
        "pricing": "Freemium",
        "description": "Your personal AI marketer.",
        "url": "https://www.contlo.com",
        "icon": "fas fa-bullhorn",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989466/superagi_msapio.jpg",
        "dateAdded": 1697760000000,
        "tags": [
          "contlo ai",
          "ai marketing",
          "freemium",
          "contlo",
          "your",
          "personal",
          "marketer"
        ],
        "rating": 4.1,
        "reviewCount": "375+"
      },
      {
        "name": "Waymark AI",
        "pricing": "Freemium",
        "description": "Create business commercials with AI in 1 click.",
        "url": "https://www.waymark.com",
        "icon": "fas fa-bullhorn",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991425/waymark_p3rs0w.jpg",
        "dateAdded": 1698019200000,
        "tags": [
          "waymark ai",
          "ai marketing",
          "freemium",
          "waymark",
          "business",
          "commercials",
          "click"
        ],
        "rating": 4.8,
        "reviewCount": "412+"
      },
      {
        "name": "Postaga",
        "pricing": "Freemium",
        "description": "AI-powered sales outreach.",
        "url": "https://postaga.com",
        "icon": "fas fa-bullhorn",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986943/postaga_jurjaf.jpg",
        "dateAdded": 1698192000000,
        "tags": [
          "postaga",
          "ai marketing",
          "freemium",
          "aipowered",
          "sales",
          "outreach"
        ],
        "rating": 4.9,
        "reviewCount": "109+"
      }
    ]
  },
  {
    "id": "voice-tools",
    "name": "AI Voice/Audio Tools",
    "tools": [
      {
        "name": "Eleven Labs",
        "pricing": "Freemium",
        "description": "Generate ultra-realistic human voice from scripts.",
        "url": "https://elevenlabs.io",
        "icon": "fas fa-microphone",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976444/elevenlabs_dbzkgf.jpg",
        "dateAdded": 1698796800000,
        "tags": [
          "eleven labs",
          "ai voice/audio",
          "freemium",
          "eleven",
          "labs",
          "ultrarealistic",
          "human",
          "voice",
          "scripts"
        ],
        "rating": 4.1,
        "reviewCount": "177+"
      },
      {
        "name": "DupDub",
        "pricing": "Freemium",
        "description": "AI avatars, 150+ realistic voices, and video dubbing.",
        "url": "https://www.dupdub.com",
        "icon": "fas fa-microphone",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763975490/dupdup_fxw3no.jpg",
        "dateAdded": 1757010600000,
        "tags": [
          "dupdub",
          "ai voice/audio",
          "freemium",
          "avatars",
          "150",
          "realistic",
          "voices",
          "video",
          "dubbing"
        ],
        "rating": 4.1,
        "reviewCount": "284+"
      },
      {
        "name": "Podcastle AI",
        "pricing": "Freemium",
        "description": "Create, edit, and host podcasts using AI tools.",
        "url": "https://podcastle.ai",
        "icon": "fas fa-microphone",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763987884/Podcastai_rfyu1s.jpg",
        "dateAdded": 1699488000000,
        "tags": [
          "podcastle ai",
          "ai voice/audio",
          "freemium",
          "podcastle",
          "edit",
          "host",
          "podcasts",
          "tools"
        ],
        "rating": 4.9,
        "reviewCount": "171+"
      },
      {
        "name": "Voice Maker",
        "pricing": "Freemium",
        "description": "Create AI voiceovers for commercial use.",
        "url": "https://voicemaker.in",
        "icon": "fas fa-microphone",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991297/voicemaker_ekncjx.jpg",
        "dateAdded": 1700179200000,
        "tags": [
          "voice maker",
          "ai voice/audio",
          "freemium",
          "voice",
          "maker",
          "voiceovers",
          "commercial"
        ],
        "rating": 4,
        "reviewCount": "342+"
      },
      {
        "name": "Speechify",
        "pricing": "Freemium",
        "description": "Read text aloud using AI on any device.",
        "url": "https://speechify.com",
        "icon": "fas fa-microphone",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989653/speechify_glpgyf.jpg",
        "dateAdded": 1700611200000,
        "tags": [
          "speechify",
          "ai voice/audio",
          "freemium",
          "read",
          "text",
          "aloud",
          "any",
          "device"
        ],
        "rating": 4.7,
        "reviewCount": "382+"
      },
      {
        "name": "Dubverse",
        "pricing": "Freemium",
        "description": "Fast and accurate AI-powered text-to-speech and dubbing.",
        "url": "https://dubverse.ai",
        "icon": "fas fa-microphone",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763975483/Dubverse_hz0csm.jpg",
        "dateAdded": 1700956800000,
        "tags": [
          "dubverse",
          "ai voice/audio",
          "freemium",
          "accurate",
          "aipowered",
          "texttospeech",
          "dubbing"
        ],
        "rating": 4.4,
        "reviewCount": "361+"
      },
      {
        "name": "TTS Maker",
        "pricing": "Freemium",
        "description": "Convert text to audio files easily.",
        "url": "https://ttsmp3.com",
        "icon": "fas fa-microphone",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990525/ttsmp3_mmesce.jpg",
        "dateAdded": 1701388800000,
        "tags": [
          "tts maker",
          "ai voice/audio",
          "freemium",
          "tts",
          "maker",
          "convert",
          "text",
          "audio",
          "files",
          "easily"
        ],
        "rating": 4.7,
        "reviewCount": "188+"
      },
      {
        "name": "Verbatik",
        "pricing": "Freemium",
        "description": "100+ realistic voices with text-to-speech options.",
        "url": "https://www.verbatik.com",
        "icon": "fas fa-microphone",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991232/verbatik_qxk4u8.jpg",
        "dateAdded": 1701734400000,
        "tags": [
          "verbatik",
          "ai voice/audio",
          "freemium",
          "100",
          "realistic",
          "voices",
          "texttospeech",
          "options"
        ],
        "rating": 4.1,
        "reviewCount": "34+"
      },
      {
        "name": "Play AI",
        "pricing": "Freemium",
        "description": "The most realistic free AI text-to-speech.",
        "url": "https://play.ht",
        "icon": "fas fa-microphone",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763987415/Play_c6wgmf.jpg",
        "dateAdded": 1702339200000,
        "tags": [
          "play ai",
          "ai voice/audio",
          "freemium",
          "play",
          "realistic",
          "texttospeech"
        ],
        "rating": 4.3,
        "reviewCount": "259+"
      },
      {
        "name": "Songburst AI",
        "pricing": "Freemium",
        "description": "AI tool to create and customize songs using lyrics and genres of your choice.",
        "icon": "fas fa-music",
        "url": "https://www.songburst.ai/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989612/songburst_vihvus.jpg",
        "dateAdded": 1702425600000,
        "tags": [
          "songburst ai",
          "ai voice/audio",
          "freemium",
          "songburst",
          "customize",
          "songs",
          "lyrics",
          "genres",
          "your",
          "choice"
        ],
        "rating": 4.5,
        "reviewCount": "369+"
      },
      {
        "name": "Adobe Podcast",
        "pricing": "Freemium",
        "description": "AI-enhanced podcast editor by Adobe with tools like Enhance Speech for pro audio.",
        "icon": "fas fa-podcast",
        "url": "https://podcast.adobe.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763988728/Podcast_kiz2aw.jpg",
        "dateAdded": 1702598400000,
        "tags": [
          "adobe podcast",
          "ai voice/audio",
          "freemium",
          "adobe",
          "podcast",
          "aienhanced",
          "editor",
          "tools",
          "enhance",
          "speech",
          "pro",
          "audio"
        ],
        "rating": 4.5,
        "reviewCount": "38+"
      },
      {
        "name": "Voice Cloning",
        "pricing": "Freemium",
        "description": "Clone your voice with AI for personalized audio content.",
        "url": "https://www.voicecloning.ai",
        "icon": "fas fa-microphone",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991272/voicecloning_kgnk2r.jpg",
        "dateAdded": 1702771200000,
        "tags": [
          "voice cloning",
          "ai voice/audio",
          "freemium",
          "voice",
          "cloning",
          "clone",
          "your",
          "personalized",
          "audio",
          "content"
        ],
        "rating": 4.1,
        "reviewCount": "233+"
      },
      {
        "name": "Voicify",
        "pricing": "Freemium",
        "description": "AI voice generator with over 100+ voices and accents.",
        "url": "https://voicify.com",
        "icon": "fas fa-microphone",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991309/voicify_jvfo23.jpg",
        "dateAdded": 1702857600000,
        "tags": [
          "voicify",
          "ai voice/audio",
          "freemium",
          "voice",
          "generator",
          "over",
          "100",
          "voices",
          "accents"
        ],
        "rating": 4.4,
        "reviewCount": "213+"
      },
      {
        "name": "Lovo AI",
        "pricing": "Freemium",
        "description": "AI voice generator and text-to-speech tool with realistic voiceovers for creators.",
        "icon": "fas fa-microphone",
        "url": "https://www.lovo.ai/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985224/lovo_lzztip.jpg",
        "dateAdded": 1703980800000,
        "tags": [
          "lovo ai",
          "ai voice/audio",
          "freemium",
          "lovo",
          "voice",
          "generator",
          "texttospeech",
          "realistic",
          "voiceovers",
          "creators"
        ],
        "rating": 4.3,
        "reviewCount": "388+"
      },
      {
        "name": "Murf AI",
        "pricing": "Freemium",
        "description": "AI-powered text-to-speech platform for creating realistic voiceovers.",
        "url": "https://murf.ai/",
        "icon": "fas fa-microphone",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985962/murf_bhiyxk.jpg",
        "dateAdded": 1727827200000,
        "tags": [
          "murf ai",
          "ai voice/audio",
          "freemium",
          "murf",
          "aipowered",
          "texttospeech",
          "creating",
          "realistic",
          "voiceovers"
        ],
        "rating": 4.7,
        "reviewCount": "239+"
      },
      {
        "name": "Delphi",
        "pricing": "Freemium",
        "description": "AI platform to clone your voice and create a digital twin for content creation.",
        "url": "https://delphi.ai/",
        "icon": "fas fa-clone",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763975504/delphi_qbja9h.jpg",
        "dateAdded": 1728432000000,
        "tags": [
          "delphi",
          "ai voice/audio",
          "freemium",
          "clone",
          "your",
          "voice",
          "digital",
          "twin",
          "content",
          "creation"
        ],
        "rating": 4.6,
        "reviewCount": "112+"
      }
    ]
  },
  {
    "id": "website-builders",
    "name": "AI Website Builders",
    "tools": [
      {
        "name": "Cosmofeed",
        "pricing": "Freemium",
        "description": "Sell digital products or services for free.",
        "url": "https://cosmofeed.com",
        "icon": "fas fa-globe",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973963/cosmofeed_h0jopl.jpg",
        "dateAdded": 1729123200000,
        "tags": [
          "cosmofeed",
          "ai website builders",
          "freemium",
          "sell",
          "digital",
          "products",
          "services"
        ],
        "rating": 4.6,
        "reviewCount": "174+"
      },
      {
        "name": "Systeme",
        "pricing": "Freemium",
        "description": "Landing page builder, webinar, sales page, and email list manager.",
        "url": "https://systeme.io",
        "icon": "fas fa-globe",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989483/systeme_okhllq.jpg",
        "dateAdded": 1729641600000,
        "tags": [
          "systeme",
          "ai website builders",
          "freemium",
          "landing",
          "page",
          "builder",
          "webinar",
          "sales",
          "email",
          "list",
          "manager"
        ],
        "rating": 4.4,
        "reviewCount": "357+"
      },
      {
        "name": "Mixo IO",
        "pricing": "Freemium",
        "description": "AI website in 60 seconds with drag-and-drop templates.",
        "url": "https://mixo.io",
        "icon": "fas fa-globe",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986049/mixo_gazbvy.jpg",
        "dateAdded": 1729814400000,
        "tags": [
          "mixo io",
          "ai website builders",
          "freemium",
          "mixo",
          "website",
          "seconds",
          "draganddrop",
          "templates"
        ],
        "rating": 4.4,
        "reviewCount": "43+"
      },
      {
        "name": "Groove Funnel",
        "pricing": "Freemium",
        "description": "Free funnel builder alternative to ClickFunnels.",
        "url": "https://www.groove.cm",
        "icon": "fas fa-globe",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983230/groove_jrpyd0.jpg",
        "dateAdded": 1730073600000,
        "tags": [
          "groove funnel",
          "ai website builders",
          "freemium",
          "groove",
          "funnel",
          "builder",
          "alternative",
          "clickfunnels"
        ],
        "rating": 4.9,
        "reviewCount": "227+"
      },
      {
        "name": "Carrd",
        "pricing": "Freemium",
        "description": "Create a one-page free responsive website.",
        "url": "https://carrd.co",
        "icon": "fas fa-globe",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973790/captions_qb23mq.jpg",
        "dateAdded": 1730332800000,
        "tags": [
          "carrd",
          "ai website builders",
          "freemium",
          "onepage",
          "responsive",
          "website"
        ],
        "rating": 4.4,
        "reviewCount": "362+"
      },
      {
        "name": "Beacons",
        "pricing": "Freemium",
        "description": "Alternative to Linktree with monetization options.",
        "url": "https://beacons.ai",
        "icon": "fas fa-globe",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972963/beacons_jatrtv.jpg",
        "dateAdded": 1730678400000,
        "tags": [
          "beacons",
          "ai website builders",
          "freemium",
          "alternative",
          "linktree",
          "monetization",
          "options"
        ],
        "rating": 4.8,
        "reviewCount": "429+"
      },
      {
        "name": "Payhip",
        "pricing": "Freemium",
        "description": "Sell your digital products from anywhere in the world.",
        "url": "https://payhip.com",
        "icon": "fas fa-globe",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763987382/payhip_hzpht0.jpg",
        "dateAdded": 1731110400000,
        "tags": [
          "payhip",
          "ai website builders",
          "freemium",
          "sell",
          "your",
          "digital",
          "products",
          "anywhere",
          "world"
        ],
        "rating": 4.9,
        "reviewCount": "399+"
      },
      {
        "name": "Gumroad",
        "pricing": "Freemium",
        "description": "Sell your digital products from anywhere in the world.",
        "url": "https://gumroad.com",
        "icon": "fas fa-globe",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983233/gumroad_qkqc6w.jpg",
        "dateAdded": 1731715200000,
        "tags": [
          "gumroad",
          "ai website builders",
          "freemium",
          "sell",
          "your",
          "digital",
          "products",
          "anywhere",
          "world"
        ],
        "rating": 4.4,
        "reviewCount": "305+"
      },
      {
        "name": "10Web",
        "pricing": "Freemium",
        "description": "Create websites with AI in a few clicks.",
        "url": "https://10web.io",
        "icon": "fas fa-globe",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972205/10web_upg3wk.jpg",
        "dateAdded": 1732492800000,
        "tags": [
          "10web",
          "ai website builders",
          "freemium",
          "websites",
          "few",
          "clicks"
        ],
        "rating": 4.2,
        "reviewCount": "483+"
      },
      {
        "name": "Durable",
        "pricing": "Freemium",
        "description": "AI website builder.",
        "url": "https://durable.co",
        "icon": "fas fa-globe",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763975491/Durable_x9vkvq.jpg",
        "dateAdded": 1732665600000,
        "tags": [
          "durable",
          "ai website builders",
          "freemium",
          "website",
          "builder"
        ],
        "rating": 4.2,
        "reviewCount": "464+"
      },
      {
        "name": "Same.new",
        "pricing": "Freemium",
        "description": "copy any website and make clone.",
        "url": "https://same.new",
        "icon": "fas fa-globe",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989488/same_baes6l.jpg",
        "dateAdded": 1733270400000,
        "tags": [
          "same.new",
          "ai website builders",
          "freemium",
          "samenew",
          "copy",
          "any",
          "website",
          "clone"
        ],
        "rating": 4.3,
        "reviewCount": "461+"
      },
      {
        "name": "Emergent",
        "pricing": "Freemium",
        "description": "Agent‑powered AI development platform that builds full‑stack apps—plan, code, test & deploy—from natural language prompts, no manual coding required.",
        "icon": "fas fa-robot",
        "url": "https://emergent.sh/",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976571/emergent_wfbeha.jpg",
        "dateAdded": 1734393600000,
        "tags": [
          "emergent",
          "ai website builders",
          "freemium",
          "agentpowered",
          "development",
          "builds",
          "fullstack",
          "appsplan",
          "code",
          "test",
          "deployfrom",
          "natural",
          "language",
          "prompts",
          "manual"
        ],
        "rating": 4.1,
        "reviewCount": "383+"
      },
      {
        "name": "Uizard",
        "pricing": "Freemium",
        "description": "AI design tool to transform sketches or wireframes into working UI prototypes.",
        "icon": "fas fa-drafting-compass",
        "url": "https://uizard.io/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991215/uizard_ihlsqk.jpg",
        "dateAdded": 1734480000000,
        "tags": [
          "uizard",
          "ai website builders",
          "freemium",
          "design",
          "transform",
          "sketches",
          "wireframes",
          "into",
          "working",
          "prototypes"
        ],
        "rating": 4.8,
        "reviewCount": "323+"
      },
      {
        "name": "UiMagic",
        "pricing": "Freemium",
        "description": "Tool that helps create user interfaces with the help of AI suggestions.",
        "icon": "fas fa-magic",
        "url": "https://uimagic.ai/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989509/seodomain_jxf14y.jpg",
        "dateAdded": 1734998400000,
        "tags": [
          "uimagic",
          "ai website builders",
          "freemium",
          "helps",
          "interfaces",
          "suggestions"
        ],
        "rating": 4.5,
        "reviewCount": "330+"
      },
      {
        "name": "rocket.new",
        "pricing": "Freemium",
        "description": "A platform to quickly launch and manage new projects. Best-for: Startups, entrepreneurs.",
        "url": "https://www.rocket.new/",
        "icon": "fas fa-rocket",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989233/rocket_iwu1rc.jpg",
        "dateAdded": 1736294400000,
        "tags": [
          "rocket.new",
          "ai website builders",
          "freemium",
          "rocketnew",
          "quickly",
          "launch",
          "manage",
          "projects",
          "bestfor",
          "startups",
          "entrepreneurs"
        ],
        "rating": 4.7,
        "reviewCount": "35+"
      }
    ]
  },
  {
    "id": "music-generators",
    "name": "AI Music Generators",
    "tools": [
      {
        "name": "Suno",
        "pricing": "Freemium",
        "description": "Create catchy tunes with AI magic! 🎵",
        "icon": "fas fa-wave-square",
        "url": "https://suno.ai",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989463/suno_hjfids.jpg",
        "dateAdded": 1737331200000,
        "tags": [
          "suno",
          "ai music generators",
          "freemium",
          "catchy",
          "tunes",
          "magic"
        ],
        "rating": 4,
        "reviewCount": "260+"
      },
      {
        "name": "Soundraw",
        "pricing": "Freemium",
        "description": "Royalty-free AI music for your projects.",
        "icon": "fas fa-wave-square",
        "url": "https://soundraw.io",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989640/soundraw_yiwesa.jpg",
        "dateAdded": 1737763200000,
        "tags": [
          "soundraw",
          "ai music generators",
          "freemium",
          "royaltyfree",
          "music",
          "your",
          "projects"
        ],
        "rating": 4,
        "reviewCount": "134+"
      },
      {
        "name": "Soundful",
        "pricing": "Freemium",
        "description": "Soundful helps you generate unique, royalty-free tracks.",
        "icon": "fas fa-wave-square",
        "url": "https://soundful.com",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989621/soundfu_tk4h7c.jpg",
        "dateAdded": 1738972800000,
        "tags": [
          "soundful",
          "ai music generators",
          "freemium",
          "helps",
          "you",
          "unique",
          "royaltyfree",
          "tracks"
        ],
        "rating": 4.4,
        "reviewCount": "333+"
      }
    ]
  },
  {
    "id": "image-generators",
    "name": "AI Image Generators",
    "tools": [
      {
        "name": "Flux Pro",
        "pricing": "Freemium",
        "description": "Realistic image generation with better hands and text.",
        "url": "https://www.fluxpro.ai",
        "icon": "fas fa-palette",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976509/fluxpro_jvqhkh.jpg",
        "dateAdded": 1739404800000,
        "tags": [
          "flux pro",
          "ai image generators",
          "freemium",
          "flux",
          "pro",
          "realistic",
          "image",
          "generation",
          "hands",
          "text"
        ],
        "rating": 4.8,
        "reviewCount": "217+"
      },
      {
        "name": "Leonardo AI",
        "pricing": "Freemium",
        "description": "Best FREE AI image generation (150 free credits every day).",
        "url": "https://leonardo.ai",
        "icon": "fas fa-palette",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985165/leonardo_hw1nok.jpg",
        "dateAdded": 1740182400000,
        "tags": [
          "leonardo ai",
          "ai image generators",
          "freemium",
          "leonardo",
          "image",
          "generation",
          "150",
          "credits",
          "every"
        ],
        "rating": 4.3,
        "reviewCount": "32+"
      },
      {
        "name": "Apob AI",
        "pricing": "Freemium",
        "description": "Create your AI portrait, model from your photo, generates video.",
        "url": "https://apob.ai",
        "icon": "fas fa-palette",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972181/apob_zxxpgf.jpg",
        "dateAdded": 1741392000000,
        "tags": [
          "apob ai",
          "ai image generators",
          "freemium",
          "apob",
          "your",
          "portrait",
          "photo",
          "generates",
          "video"
        ],
        "rating": 4.2,
        "reviewCount": "92+"
      },
      {
        "name": "Nightmare AI",
        "pricing": "Freemium",
        "description": "Upscale your images to 10,000px.",
        "url": "https://www.nightmareai.com",
        "icon": "fas fa-palette",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986690/Nightmare_ihjqqj.jpg",
        "dateAdded": 1741910400000,
        "tags": [
          "nightmare ai",
          "ai image generators",
          "freemium",
          "nightmare",
          "upscale",
          "your",
          "images",
          "10000px"
        ],
        "rating": 4.2,
        "reviewCount": "219+"
      },
      {
        "name": "Photo AI",
        "pricing": "Freemium",
        "description": "Make professional headshots for LinkedIn.",
        "url": "https://photoai.com",
        "icon": "fas fa-palette",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763988736/photoai_utkaw6.jpg",
        "dateAdded": 1745020800000,
        "tags": [
          "photo ai",
          "ai image generators",
          "freemium",
          "photo",
          "professional",
          "headshots",
          "linkedin"
        ],
        "rating": 4.4,
        "reviewCount": "470+"
      },
      {
        "name": "FreePik",
        "pricing": "Freemium",
        "description": "Free AI image generator that turns words into amazing images.",
        "url": "https://www.freepik.com/ai",
        "icon": "fas fa-palette",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976593/freepik_yh71ec.jpg",
        "dateAdded": 1745366400000,
        "tags": [
          "freepik",
          "ai image generators",
          "freemium",
          "image",
          "generator",
          "turns",
          "words",
          "into",
          "amazing",
          "images"
        ],
        "rating": 4.8,
        "reviewCount": "56+"
      },
      {
        "name": "CoPilot",
        "pricing": "Freemium",
        "description": "Create images from words with AI.",
        "url": "https://copilot.microsoft.com",
        "icon": "fas fa-palette",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973955/copilot_fi42qa.jpg",
        "dateAdded": 1745452800000,
        "tags": [
          "copilot",
          "ai image generators",
          "freemium",
          "images",
          "words"
        ],
        "rating": 4.6,
        "reviewCount": "425+"
      },
      {
        "name": "InstantArt AI",
        "pricing": "Freemium",
        "description": "Free tool for text-to-image generation with AI.",
        "url": "https://instantart.io",
        "icon": "fas fa-palette",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984231/InstantArt_rvu941.png",
        "dateAdded": 1745625600000,
        "tags": [
          "instantart ai",
          "ai image generators",
          "freemium",
          "instantart",
          "texttoimage",
          "generation"
        ],
        "rating": 4.9,
        "reviewCount": "64+"
      },
      {
        "name": "Midjourney",
        "pricing": "Freemium",
        "description": "Stunning AI art from text prompts.",
        "icon": "fas fa-palette",
        "url": "https://midjourney.com",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986024/midjourney_m9oppc.jpg",
        "dateAdded": 1746057600000,
        "tags": [
          "midjourney",
          "ai image generators",
          "freemium",
          "stunning",
          "art",
          "text",
          "prompts"
        ],
        "rating": 4.7,
        "reviewCount": "8,200+"
      },
      {
        "name": "Fotor",
        "pricing": "Freemium",
        "description": "AI photo editing and design tool that offers one-click enhancements, background remover, AI image generation, and more.",
        "icon": "fas fa-camera-retro",
        "url": "https://www.fotor.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976600/fotor_cwubao.jpg",
        "dateAdded": 1746489600000,
        "tags": [
          "fotor",
          "ai image generators",
          "freemium",
          "photo",
          "editing",
          "design",
          "oneclick",
          "enhancements",
          "background",
          "remover",
          "image",
          "generation"
        ],
        "rating": 4.3,
        "reviewCount": "161+"
      },
      {
        "name": "DALL-E 3",
        "pricing": "Freemium",
        "description": "Advanced image generation model by OpenAI that creates high-quality visuals from natural language prompts.",
        "icon": "fas fa-brain",
        "url": "https://openai.com/dall-e",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763975495/Dall-E_jmangj.jpg",
        "dateAdded": 1746748800000,
        "tags": [
          "dall-e 3",
          "ai image generators",
          "freemium",
          "dalle",
          "image",
          "generation",
          "openai",
          "creates",
          "highquality",
          "visuals",
          "natural",
          "language",
          "prompts"
        ],
        "rating": 4.5,
        "reviewCount": "308+"
      },
      {
        "name": "Stability AI",
        "pricing": "Freemium",
        "description": "Creators of Stable Diffusion and other open-source generative AI tools for image, language, and audio synthesis.",
        "icon": "fas fa-flask",
        "url": "https://stability.ai/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989660/stability_ytsyvz.jpg",
        "dateAdded": 1747008000000,
        "tags": [
          "stability ai",
          "ai image generators",
          "freemium",
          "stability",
          "creators",
          "stable",
          "diffusion",
          "opensource",
          "generative",
          "tools",
          "image",
          "language",
          "audio",
          "synthesis"
        ],
        "rating": 4.6,
        "reviewCount": "185+"
      },
      {
        "name": "Adobe Firefly",
        "pricing": "Freemium",
        "description": "A family of creative generative AI models for image and text effect generation.",
        "url": "https://www.adobe.com/sensei/generative-ai/firefly.html",
        "icon": "fas fa-palette",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976137/firefly_nmnxbn.jpg",
        "dateAdded": 1747440000000,
        "tags": [
          "adobe firefly",
          "ai image generators",
          "freemium",
          "adobe",
          "firefly",
          "family",
          "creative",
          "generative",
          "image",
          "text",
          "effect",
          "generation"
        ],
        "rating": 4.7,
        "reviewCount": "379+"
      },
      {
        "name": "Ideogram",
        "pricing": "Freemium",
        "description": "AI image generator focused on creating reliable text within images.",
        "url": "https://ideogram.ai",
        "icon": "fas fa-palette",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984157/ideogram_e75p03.jpg",
        "dateAdded": 1748649600000,
        "tags": [
          "ideogram",
          "ai image generators",
          "freemium",
          "image",
          "generator",
          "focused",
          "creating",
          "reliable",
          "text",
          "within",
          "images"
        ],
        "rating": 4.4,
        "reviewCount": "71+"
      },
      {
        "name": "Recraft",
        "pricing": "Freemium",
        "description": "Generate and edit vector art, icons, and illustrations in a consistent brand style.",
        "url": "https://www.recraft.ai",
        "icon": "fas fa-palette",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989216/recraft_ykhhbj.jpg",
        "dateAdded": 1749600000000,
        "tags": [
          "recraft",
          "ai image generators",
          "freemium",
          "edit",
          "vector",
          "art",
          "icons",
          "illustrations",
          "consistent",
          "brand",
          "style"
        ],
        "rating": 4.6,
        "reviewCount": "45+"
      },
      {
        "name": "Stable Diffusion",
        "pricing": "Freemium",
        "description": "A popular open-source model for generating detailed images from text.",
        "url": "https://stablediffusionweb.com",
        "icon": "fas fa-palette",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989666/stablediffusionweb_cpd1yz.jpg",
        "dateAdded": 1749772800000,
        "tags": [
          "stable diffusion",
          "ai image generators",
          "freemium",
          "stable",
          "diffusion",
          "popular",
          "opensource",
          "generating",
          "detailed",
          "images",
          "text"
        ],
        "rating": 4.7,
        "reviewCount": "4,200+"
      },
      {
        "name": "FLUX.1",
        "pricing": "Freemium",
        "description": "A fast and powerful text-to-image model for high-quality, detailed outputs.",
        "url": "https://flux1.ai/",
        "icon": "fas fa-palette",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976508/flux1_w0weio.jpg",
        "dateAdded": 1750809600000,
        "tags": [
          "flux.1",
          "ai image generators",
          "freemium",
          "flux1",
          "texttoimage",
          "highquality",
          "detailed",
          "outputs"
        ],
        "rating": 4.8,
        "reviewCount": "215+"
      },
      {
        "name": "animated drawings",
        "pricing": "Freemium",
        "description": "Animate your sketches and drawings of characters automatically. Best-for: Artists, parents, creators.",
        "url": "https://sketch.metademolab.com/",
        "icon": "fas fa-pencil-ruler",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989572/sketch_olukfu.jpg",
        "dateAdded": 1750896000000,
        "tags": [
          "animated drawings",
          "ai image generators",
          "freemium",
          "animated",
          "drawings",
          "animate",
          "your",
          "sketches",
          "characters",
          "bestfor",
          "artists",
          "parents",
          "creators"
        ],
        "rating": 4.1,
        "reviewCount": "96+"
      }
    ]
  },
  {
    "id": "data-analysis",
    "name": "AI Data Analysis Tools",
    "tools": [
      {
        "name": "Tableau AI",
        "pricing": "Freemium",
        "description": "Visualize data like a pro with AI insights. 📊",
        "icon": "fas fa-chart-bar",
        "url": "https://tableau.com",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990543/tableau_b97eiv.jpg",
        "dateAdded": 1752105600000,
        "tags": [
          "tableau ai",
          "ai data analysis",
          "freemium",
          "tableau",
          "visualize",
          "data",
          "pro",
          "insights"
        ],
        "rating": 4.8,
        "reviewCount": "21+"
      },
      {
        "name": "Akkio",
        "pricing": "Freemium",
        "description": "No-code AI for data predictions.",
        "icon": "fas fa-chart-bar",
        "url": "https://akkio.com",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972180/akkio_biofqc.jpg",
        "dateAdded": 1752969600000,
        "tags": [
          "akkio",
          "ai data analysis",
          "freemium",
          "nocode",
          "data",
          "predictions"
        ],
        "rating": 4.8,
        "reviewCount": "246+"
      },
      {
        "name": "Polymer",
        "pricing": "Freemium",
        "description": "Auto-build dashboards and analyze your data using AI.",
        "icon": "fas fa-chart-bar",
        "url": "https://www.polymersearch.com",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763988698/polymer_vzmddm.jpg",
        "dateAdded": 1753488000000,
        "tags": [
          "polymer",
          "ai data analysis",
          "freemium",
          "autobuild",
          "dashboards",
          "analyze",
          "your",
          "data"
        ],
        "rating": 4.6,
        "reviewCount": "160+"
      }
    ]
  },
  {
    "id": "ai-diagrams",
    "name": "UML, ER, Use Case Diagrams",
    "tools": [
      {
        "name": "AI Use Case Diagram Generator",
        "pricing": "Freemium",
        "description": "Generate UML diagrams from plain text effortlessly.",
        "icon": "fas fa-project-diagram",
        "url": "https://plantuml.com",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763988721/plantuml_c5lgrr.jpg",
        "dateAdded": 1754006400000,
        "tags": [
          "ai use case diagram generator",
          "uml, er, use case diagrams",
          "freemium",
          "case",
          "diagram",
          "generator",
          "uml",
          "diagrams",
          "plain",
          "text",
          "effortlessly"
        ],
        "rating": 4.7,
        "reviewCount": "56+"
      }
    ]
  },
  {
    "id": "Portfolio",
    "name": "Ai Portfolio",
    "tools": [
      {
        "name": "Macaly",
        "pricing": "Freemium",
        "description": "AI for personal productivity and planning. 📅",
        "icon": "fas fa-calendar-alt",
        "url": "https://www.macaly.com/",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985970/macaly_ip0k4s.jpg",
        "dateAdded": 1754092800000,
        "tags": [
          "macaly",
          "ai portfolio",
          "freemium",
          "personal",
          "productivity",
          "planning"
        ],
        "rating": 4.9,
        "reviewCount": "444+"
      },
      {
        "name": "Bolt.new",
        "pricing": "Freemium",
        "description": "AI to launch and test startup ideas fast. ⚡",
        "icon": "fas fa-rocket",
        "url": "https://bolt.new",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972952/bolt_o6lwvm.jpg",
        "dateAdded": 1754697600000,
        "tags": [
          "bolt.new",
          "ai portfolio",
          "freemium",
          "boltnew",
          "launch",
          "test",
          "startup",
          "ideas"
        ],
        "rating": 4,
        "reviewCount": "162+"
      },
      {
        "name": "Lovable",
        "pricing": "Freemium",
        "description": "AI for branding, naming, and storytelling. 💖",
        "icon": "fas fa-heart",
        "url": "https://lovable.so",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985217/lovable_uyeijn.jpg",
        "dateAdded": 1755043200000,
        "tags": [
          "lovable",
          "ai portfolio",
          "freemium",
          "branding",
          "naming",
          "storytelling"
        ],
        "rating": 4.8,
        "reviewCount": "301+"
      },
      {
        "name": "Contra",
        "pricing": "Freemium",
        "description": "AI-powered platform for independent creatives. 🧑‍🎨",
        "icon": "fas fa-briefcase",
        "url": "https://contra.com",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973954/contra_awy1ol.jpg",
        "dateAdded": 1755043200000,
        "tags": [
          "contra",
          "ai portfolio",
          "freemium",
          "aipowered",
          "independent",
          "creatives"
        ],
        "rating": 4.8,
        "reviewCount": "490+"
      },
      {
        "name": "Framer",
        "pricing": "Freemium",
        "description": "AI-powered site builder for designers. 🖌️",
        "icon": "fas fa-laptop-code",
        "url": "https://framer.com",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976577/framer_b9xhso.jpg",
        "dateAdded": 1755475200000,
        "tags": [
          "framer",
          "ai portfolio",
          "freemium",
          "aipowered",
          "site",
          "builder",
          "designers"
        ],
        "rating": 4.2,
        "reviewCount": "19+"
      },
      {
        "name": "Goodbrief.io",
        "pricing": "Freemium",
        "description": "AI-generated design briefs for practice. ✍️",
        "icon": "fas fa-lightbulb",
        "url": "https://goodbrief.io",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983254/goodbrief_a8ys7s.jpg",
        "dateAdded": 1755820800000,
        "tags": [
          "goodbrief.io",
          "ai portfolio",
          "freemium",
          "goodbriefio",
          "aigenerated",
          "design",
          "briefs",
          "practice"
        ],
        "rating": 4.5,
        "reviewCount": "97+"
      },
      {
        "name": "Cofolios",
        "pricing": "Freemium",
        "description": "AI-assisted portfolio builder for designers. 🎨",
        "icon": "fas fa-folder-open",
        "url": "https://cofolios.com",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973944/cofolios_pqbqvs.jpg",
        "dateAdded": 1755907200000,
        "tags": [
          "cofolios",
          "ai portfolio",
          "freemium",
          "aiassisted",
          "portfolio",
          "builder",
          "designers"
        ],
        "rating": 4,
        "reviewCount": "124+"
      },
      {
        "name": "Oddo",
        "pricing": "Freemium",
        "description": "AI-powered tool to remix and generate visual assets. 🌀",
        "icon": "fas fa-magic",
        "url": "https://oddo.ai",
        "isNew": true,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986802/oddo_vtjjfv.jpg",
        "dateAdded": 1757030400000,
        "tags": [
          "oddo",
          "ai portfolio",
          "freemium",
          "aipowered",
          "remix",
          "visual",
          "assets"
        ],
        "rating": 4.5,
        "reviewCount": "231+"
      },
      {
        "name": "Awwwards",
        "pricing": "Freemium",
        "description": "Showcase of the best web design & innovation. 🏆",
        "icon": "fas fa-award",
        "url": "https://awwwards.com",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972205/awwwards_vjb1jl.jpg",
        "dateAdded": 1757635200000,
        "tags": [
          "awwwards",
          "ai portfolio",
          "freemium",
          "showcase",
          "web",
          "design",
          "innovation"
        ],
        "rating": 4.2,
        "reviewCount": "246+"
      },
      {
        "name": "StyleAI",
        "pricing": "Freemium",
        "description": "AI-powered tool for generating, optimizing, and managing websites with SEO and marketing in mind.",
        "icon": "fas fa-paint-brush",
        "url": "https://www.styleai.io",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989691/styleai_a4snrw.jpg",
        "dateAdded": 1757894400000,
        "tags": [
          "styleai",
          "ai portfolio",
          "freemium",
          "aipowered",
          "generating",
          "optimizing",
          "managing",
          "websites",
          "seo",
          "marketing",
          "mind"
        ],
        "rating": 4.1,
        "reviewCount": "289+"
      }
    ]
  },
  {
    "id": "ai-scheduling",
    "name": "AI Scheduling",
    "tools": [
      {
        "name": "Calendly",
        "pricing": "Freemium",
        "description": "Automate meeting scheduling and eliminate back-and-forth emails.",
        "url": "https://calendly.com",
        "icon": "fas fa-calendar-alt",
        "isNew": false,
        "comingsoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973780/calendy_b8krrc.jpg",
        "dateAdded": 1758153600000,
        "tags": [
          "calendly",
          "ai scheduling",
          "freemium",
          "automate",
          "meeting",
          "scheduling",
          "eliminate",
          "backandforth",
          "emails"
        ],
        "rating": 4.1,
        "reviewCount": "359+"
      },
      {
        "name": "Clockwise",
        "pricing": "Freemium",
        "description": "A smart calendar assistant that optimizes your team's schedule for focus time.",
        "url": "https://www.getclockwise.com/",
        "icon": "fas fa-clock",
        "isNew": false,
        "comingsoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983245/getclockwise_bnaxax.jpg",
        "dateAdded": 1758931200000,
        "tags": [
          "clockwise",
          "ai scheduling",
          "freemium",
          "calendar",
          "assistant",
          "optimizes",
          "your",
          "teams",
          "schedule",
          "focus"
        ],
        "rating": 4.8,
        "reviewCount": "123+"
      },
      {
        "name": "Motion",
        "pricing": "Freemium",
        "description": "Uses AI to plan your day, manage projects, and schedule meetings automatically.",
        "url": "https://www.usemotion.com/",
        "icon": "fas fa-running",
        "isNew": true,
        "comingsoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991246/usemotion_koar7o.jpg",
        "dateAdded": 1760140800000,
        "tags": [
          "motion",
          "ai scheduling",
          "freemium",
          "uses",
          "plan",
          "your",
          "manage",
          "projects",
          "schedule",
          "meetings"
        ],
        "rating": 4.7,
        "reviewCount": "156+"
      },
      {
        "name": "Reclaim AI",
        "pricing": "Freemium",
        "description": "Smart time blocking for your calendar to defend your habits, tasks, and routines.",
        "url": "https://reclaim.ai/",
        "icon": "fas fa-calendar-check",
        "isNew": false,
        "comingsoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989162/reclaim_lb9rb1.jpg",
        "dateAdded": 1760227200000,
        "tags": [
          "reclaim ai",
          "ai scheduling",
          "freemium",
          "reclaim",
          "blocking",
          "your",
          "calendar",
          "defend",
          "habits",
          "tasks",
          "routines"
        ],
        "rating": 4.1,
        "reviewCount": "385+"
      },
      {
        "name": "Trevor AI",
        "pricing": "Freemium",
        "description": "An AI-powered daily planner that turns your to-do lists into a time-blocked schedule.",
        "url": "https://trevorai.com/",
        "icon": "fas fa-list-alt",
        "isNew": true,
        "comingsoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990501/Trevor_dlq3rf.jpg",
        "dateAdded": 1760313600000,
        "tags": [
          "trevor ai",
          "ai scheduling",
          "freemium",
          "trevor",
          "aipowered",
          "daily",
          "planner",
          "turns",
          "your",
          "todo",
          "lists",
          "into",
          "timeblocked",
          "schedule"
        ],
        "rating": 4.3,
        "reviewCount": "70+"
      }
    ]
  },
  {
    "id": "data-visualization",
    "name": "AI Data Visualization",
    "tools": [
      {
        "name": "Flourish",
        "pricing": "Freemium",
        "description": "Create beautiful and interactive charts, maps, and data stories without coding.",
        "url": "https://flourish.studio/",
        "icon": "fas fa-chart-bar",
        "isNew": false,
        "comingsoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976491/flourish_qmhu7h.jpg",
        "dateAdded": 1667260800000,
        "tags": [
          "flourish",
          "ai data visualization",
          "freemium",
          "beautiful",
          "interactive",
          "charts",
          "maps",
          "data",
          "stories",
          "without",
          "coding"
        ],
        "rating": 4.6,
        "reviewCount": "482+"
      },
      {
        "name": "Julius",
        "pricing": "Freemium",
        "description": "Your AI data analyst. Chat with your data to create visualizations and analyses.",
        "url": "https://julius.ai/",
        "icon": "fas fa-calculator",
        "isNew": true,
        "comingsoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984410/julius_tbtbbl.jpg",
        "dateAdded": 1667260800000,
        "tags": [
          "julius",
          "ai data visualization",
          "freemium",
          "your",
          "data",
          "analyst",
          "chat",
          "visualizations",
          "analyses"
        ],
        "rating": 4.5,
        "reviewCount": "160+"
      },
      {
        "name": "Zing Data",
        "pricing": "Freemium",
        "description": "AI-powered business intelligence to ask questions in plain English and get charts.",
        "url": "https://www.getzingdata.com/",
        "icon": "fas fa-chart-line",
        "isNew": false,
        "comingsoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983247/getzingdata_zvvz1a.jpg",
        "dateAdded": 1667520000000,
        "tags": [
          "zing data",
          "ai data visualization",
          "freemium",
          "zing",
          "data",
          "aipowered",
          "business",
          "intelligence",
          "ask",
          "questions",
          "plain",
          "english",
          "get",
          "charts"
        ],
        "rating": 4.3,
        "reviewCount": "344+"
      }
    ]
  },
  {
    "id": "gaming-tools",
    "name": "AI Gaming Tools",
    "tools": [
      {
        "name": "Scenario",
        "pricing": "Freemium",
        "description": "AI for game asset creation. 🎮",
        "icon": "fas fa-gamepad",
        "url": "https://scenario.com",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989491/scenario_mja6hm.jpg",
        "dateAdded": 1667692800000,
        "tags": [
          "scenario",
          "ai gaming",
          "freemium",
          "game",
          "asset",
          "creation"
        ],
        "rating": 4.9,
        "reviewCount": "385+"
      }
    ]
  },
  {
    "id": "other-tools",
    "name": "Other AI Tools",
    "tools": [
      {
        "name": "Simplified",
        "pricing": "Freemium",
        "description": "Create presentations, video editing, and write content with AI.",
        "url": "https://simplified.com",
        "icon": "fas fa-chalkboard-teacher",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989558/simplified_b3fmyw.jpg",
        "dateAdded": 1691539200000,
        "tags": [
          "simplified",
          "other ai",
          "freemium",
          "presentations",
          "video",
          "editing",
          "write",
          "content"
        ],
        "rating": 4.2,
        "reviewCount": "507+"
      },
      {
        "name": "Fastreply",
        "pricing": "Freemium",
        "description": "ChatGPT for Twitter to go viral.",
        "url": "https://fastreply.io/",
        "icon": "fas fa-tools",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976463/fastreplay_l9thp2.jpg",
        "dateAdded": 1667779200000,
        "tags": [
          "fastreply",
          "other ai",
          "freemium",
          "chatgpt",
          "twitter",
          "viral"
        ],
        "rating": 4.4,
        "reviewCount": "202+"
      },
      {
        "name": "Reimagine Home",
        "pricing": "Freemium",
        "description": "Redesign your home interior with AI-generated ideas.",
        "url": "https://www.reimaginehome.ai",
        "icon": "fas fa-tools",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989168/reimaginehome_xzp5qv.jpg",
        "dateAdded": 1668124800000,
        "tags": [
          "reimagine home",
          "other ai",
          "freemium",
          "reimagine",
          "home",
          "redesign",
          "your",
          "interior",
          "aigenerated",
          "ideas"
        ],
        "rating": 4.7,
        "reviewCount": "35+"
      },
      {
        "name": "Futurepedia",
        "pricing": "Freemium",
        "description": "Directory of AI tools for various applications.",
        "url": "https://www.futurepedia.io",
        "icon": "fas fa-tools",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976570/futurepedia_gpd7no.jpg",
        "dateAdded": 1668297600000,
        "tags": [
          "futurepedia",
          "other ai",
          "freemium",
          "directory",
          "tools",
          "various",
          "applications"
        ],
        "rating": 4.1,
        "reviewCount": "226+"
      },
      {
        "name": "Taskade",
        "pricing": "Freemium",
        "description": "AI-powered productivity and collaboration platform.",
        "url": "https://www.taskade.com/",
        "icon": "fas fa-tools",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990433/taskade_jsrciv.jpg",
        "dateAdded": 1668729600000,
        "tags": [
          "taskade",
          "other ai",
          "freemium",
          "aipowered",
          "productivity",
          "collaboration"
        ],
        "rating": 4.6,
        "reviewCount": "177+"
      },
      {
        "name": "makeinfluencer.ai",
        "pricing": "Freemium",
        "description": "makes an aiinfluencer using Ai",
        "url": "https://www.makeinfluencer.ai/#features",
        "icon": "fas fa-tools",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985998/makeinfluencer_haiome.jpg",
        "dateAdded": 1669334400000,
        "tags": [
          "makeinfluencer.ai",
          "other ai",
          "freemium",
          "makeinfluencerai",
          "makes",
          "aiinfluencer"
        ],
        "rating": 4.5,
        "reviewCount": "13+"
      },
      {
        "name": "cobalt.tools",
        "pricing": "Freemium",
        "description": "download any videos from any platform",
        "url": "https://cobalt.tools",
        "icon": "fas fa-tools",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973935/cobalt_i0vpuj.jpg",
        "dateAdded": 1669420800000,
        "tags": [
          "cobalt.tools",
          "other ai",
          "freemium",
          "cobalttools",
          "download",
          "any",
          "videos"
        ],
        "rating": 4.5,
        "reviewCount": "131+"
      },
      {
        "name": "pdf-change maker",
        "pricing": "Freemium",
        "description": "Make changes to your pdf withsame fonts",
        "url": "https://www.pdfgear.com/edit-pdf/",
        "icon": "fas fa-tools",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763987317/pdfgear_zxoodg.jpg",
        "dateAdded": 1669766400000,
        "tags": [
          "pdf-change maker",
          "other ai",
          "freemium",
          "pdfchange",
          "maker",
          "changes",
          "your",
          "pdf",
          "withsame",
          "fonts"
        ],
        "rating": 4.3,
        "reviewCount": "175+"
      },
      {
        "name": "Text Behind image",
        "pricing": "Freemium",
        "description": "Make text behind your image",
        "url": "https://textbehindimage.rexanwong.xyz/",
        "icon": "fas fa-tools",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990444/textbehindimage_ikq81x.jpg",
        "dateAdded": 1670716800000,
        "tags": [
          "text behind image",
          "other ai",
          "freemium",
          "text",
          "behind",
          "image",
          "your"
        ],
        "rating": 4.3,
        "reviewCount": "411+"
      },
      {
        "name": "Fakedetails",
        "pricing": "Freemium",
        "description": "Create a Fakedetails as you want in any apps ",
        "url": "https://fakedetail.com/",
        "icon": "fas fa-tools",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976579/fakedetails_yhsh1s.jpg",
        "dateAdded": 1670803200000,
        "tags": [
          "fakedetails",
          "other ai",
          "freemium",
          "you",
          "any",
          "apps"
        ],
        "rating": 4.8,
        "reviewCount": "173+"
      },
      {
        "name": "Tettra",
        "pricing": "Freemium",
        "description": "AI-powered knowledge management system to centralize and organize company information.",
        "icon": "fas fa-book",
        "url": "https://tettra.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990519/tettra_hhph36.jpg",
        "dateAdded": 1670889600000,
        "tags": [
          "tettra",
          "other ai",
          "freemium",
          "aipowered",
          "knowledge",
          "management",
          "centralize",
          "organize",
          "company",
          "information"
        ],
        "rating": 4.7,
        "reviewCount": "343+"
      },
      {
        "name": "Particle News",
        "pricing": "Freemium",
        "description": "AI-powered news app for personalized summaries and multi-perspective stories.",
        "icon": "fas fa-newspaper",
        "url": "https://particle.news/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986935/particle_xzib7b.jpg",
        "dateAdded": 1670976000000,
        "tags": [
          "particle news",
          "other ai",
          "freemium",
          "particle",
          "news",
          "aipowered",
          "personalized",
          "summaries",
          "multiperspective",
          "stories"
        ],
        "rating": 4.6,
        "reviewCount": "227+"
      },
      {
        "name": "Rosebud",
        "pricing": "Freemium",
        "description": "Create games, assets, and interactive stories from text prompts with no code.",
        "icon": "fas fa-gamepad",
        "url": "https://rosebud.ai/",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989251/rosebud_ldv8jf.jpg",
        "dateAdded": 1671235200000,
        "tags": [
          "rosebud",
          "other ai",
          "freemium",
          "games",
          "assets",
          "interactive",
          "stories",
          "text",
          "prompts",
          "code"
        ],
        "rating": 4.1,
        "reviewCount": "400+"
      },
      {
        "name": "Good Inside",
        "pricing": "Freemium",
        "description": "Parenting support app with an AI chatbot for instant answers to your parenting questions.",
        "icon": "fas fa-child",
        "url": "https://www.goodinside.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983258/goodinside_z1s5me.jpg",
        "dateAdded": 1673308800000,
        "tags": [
          "good inside",
          "other ai",
          "freemium",
          "inside",
          "parenting",
          "chatbot",
          "instant",
          "answers",
          "your",
          "questions"
        ],
        "rating": 4.5,
        "reviewCount": "147+"
      },
      {
        "name": "Ash",
        "pricing": "Freemium",
        "description": "AI-powered therapy companion for mental wellness and self-reflection.",
        "icon": "fas fa-comment-medical",
        "url": "https://www.talktoash.com/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972180/ash_gfkqj7.jpg",
        "dateAdded": 1673827200000,
        "tags": [
          "ash",
          "other ai",
          "freemium",
          "aipowered",
          "therapy",
          "companion",
          "mental",
          "wellness",
          "selfreflection"
        ],
        "rating": 4.8,
        "reviewCount": "226+"
      }
    ]
  },
  {
    "id": "utility-tools",
    "name": "Utility Tools",
    "tools": [
      {
        "name": "Zapier",
        "pricing": "Freemium",
        "description": "Automate workflows by connecting apps with AI.",
        "url": "https://zapier.com",
        "icon": "fas fa-cog",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991516/zapier_jt7qir.jpg",
        "dateAdded": 1673913600000,
        "tags": [
          "zapier",
          "utility",
          "freemium",
          "automate",
          "workflows",
          "connecting",
          "apps"
        ],
        "rating": 4.8,
        "reviewCount": "194+"
      },
      {
        "name": "IFTTT",
        "pricing": "Freemium",
        "description": "Connect apps and devices to automate tasks with AI applets.",
        "url": "https://ifttt.com",
        "icon": "fas fa-cog",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984221/Ifttt_azrmqv.jpg",
        "dateAdded": 1674086400000,
        "tags": [
          "ifttt",
          "utility",
          "freemium",
          "connect",
          "apps",
          "devices",
          "automate",
          "tasks",
          "applets"
        ],
        "rating": 4.8,
        "reviewCount": "116+"
      },
      {
        "name": "Make",
        "pricing": "Freemium",
        "description": "Visual automation platform for integrating apps and workflows.",
        "url": "https://www.make.com/en",
        "icon": "fas fa-cog",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985988/make_e0gq8y.jpg",
        "dateAdded": 1674172800000,
        "tags": [
          "make",
          "utility",
          "freemium",
          "visual",
          "integrating",
          "apps",
          "workflows"
        ],
        "rating": 4.1,
        "reviewCount": "437+"
      },
      {
        "name": "Airtable",
        "pricing": "Freemium",
        "description": "Organize data with AI-powered spreadsheets and automation.",
        "url": "https://www.airtable.com",
        "icon": "fas fa-cog",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972180/airtable_onlcuc.jpg",
        "dateAdded": 1674432000000,
        "tags": [
          "airtable",
          "utility",
          "freemium",
          "organize",
          "data",
          "aipowered",
          "spreadsheets"
        ],
        "rating": 4.5,
        "reviewCount": "62+"
      },
      {
        "name": "Bubble",
        "pricing": "Freemium",
        "description": "Build web apps with no-code and AI assistance.",
        "url": "https://bubble.io",
        "icon": "fas fa-cog",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972952/bubble_oqizq4.jpg",
        "dateAdded": 1674432000000,
        "tags": [
          "bubble",
          "utility",
          "freemium",
          "build",
          "web",
          "apps",
          "nocode",
          "assistance"
        ],
        "rating": 4.6,
        "reviewCount": "336+"
      },
      {
        "name": "Mindluster.com",
        "pricing": "Freemium",
        "description": "find any course you want to learn ",
        "url": "https://www.mindluster.com/",
        "icon": "fas fa-tools",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986032/mindluster_kp9wws.jpg",
        "dateAdded": 1674691200000,
        "tags": [
          "mindluster.com",
          "utility",
          "freemium",
          "mindlustercom",
          "find",
          "any",
          "course",
          "you",
          "learn"
        ],
        "rating": 4.2,
        "reviewCount": "122+"
      },
      {
        "name": "Bardeen",
        "pricing": "Freemium",
        "description": "No-code automation platform that integrates with Chrome to streamline workflows.",
        "icon": "fas fa-magic",
        "url": "https://www.bardeen.ai/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972960/bardeen_dqe3gt.jpg",
        "dateAdded": 1674950400000,
        "tags": [
          "bardeen",
          "utility",
          "freemium",
          "nocode",
          "integrates",
          "chrome",
          "streamline",
          "workflows"
        ],
        "rating": 4.4,
        "reviewCount": "398+"
      },
      {
        "name": "Integrately",
        "pricing": "Freemium",
        "description": "1-click automation to connect your apps and automate workflows.",
        "url": "https://integrately.com",
        "icon": "fas fa-link",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984235/integrately_anv9bw.jpg",
        "dateAdded": 1675468800000,
        "tags": [
          "integrately",
          "utility",
          "freemium",
          "1click",
          "connect",
          "your",
          "apps",
          "automate",
          "workflows"
        ],
        "rating": 4.1,
        "reviewCount": "211+"
      },
      {
        "name": "Monday.com",
        "pricing": "Freemium",
        "description": "A Work OS that powers teams to run projects and workflows with confidence.",
        "url": "https://monday.com",
        "icon": "fas fa-tasks",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986055/monday_hlkwhi.jpg",
        "dateAdded": 1677024000000,
        "tags": [
          "monday.com",
          "utility",
          "freemium",
          "mondaycom",
          "work",
          "powers",
          "teams",
          "run",
          "projects",
          "workflows",
          "confidence"
        ],
        "rating": 4.6,
        "reviewCount": "110+"
      },
      {
        "name": "Wrike",
        "pricing": "Freemium",
        "description": "A versatile work management platform for project planning and team collaboration.",
        "url": "https://www.wrike.com",
        "icon": "fas fa-sitemap",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991414/wrike_zeefs0.jpg",
        "dateAdded": 1677801600000,
        "tags": [
          "wrike",
          "utility",
          "freemium",
          "versatile",
          "work",
          "management",
          "project",
          "planning",
          "team",
          "collaboration"
        ],
        "rating": 4.9,
        "reviewCount": "340+"
      },
      {
        "name": "Tallyfy",
        "pricing": "Freemium",
        "description": "Workflow and process management software for automating business operations.",
        "url": "https://tallyfy.com",
        "icon": "fas fa-tasks",
        "isNew": false,
        "comingSoon": false,
        "badge": null,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990687/Tallyfy_nusvve.jpg",
        "dateAdded": 1677888000000,
        "tags": [
          "tallyfy",
          "utility",
          "freemium",
          "workflow",
          "process",
          "management",
          "automating",
          "business",
          "operations"
        ],
        "rating": 4.7,
        "reviewCount": "218+"
      },
      {
        "name": "kraftful",
        "pricing": "Freemium",
        "description": "Get poduct insights from customers revivews Best-for:Porduct development,UX teams.",
        "url": "https://www.kraftful.com",
        "icon": "fas fa-mobile-alt",
        "isNew": true,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763984750/Kraftful_ysobjs.jpg",
        "badge": "new",
        "dateAdded": 1678233600000,
        "tags": [
          "kraftful",
          "utility",
          "freemium",
          "get",
          "poduct",
          "insights",
          "customers",
          "revivews",
          "bestforporduct",
          "developmentux",
          "teams"
        ],
        "rating": 4.7,
        "reviewCount": "490+"
      },
      {
        "name": "buildmyagent.io",
        "pricing": "Freemium",
        "description": "Create AI agents that can perform tasks autonomously based on your instructions.Build and deploy custom AI agents for your business. Best-for: Developers, businesses.",
        "url": "https://buildmyagent.io",
        "icon": "fas fa-robot",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972958/buildmyagent_xa2i6p.jpg",
        "dateAdded": 1678320000000,
        "tags": [
          "buildmyagent.io",
          "utility",
          "freemium",
          "buildmyagentio",
          "agents",
          "perform",
          "tasks",
          "autonomously",
          "your",
          "instructionsbuild",
          "deploy",
          "custom",
          "business",
          "bestfor",
          "developers"
        ],
        "rating": 4.7,
        "reviewCount": "75+"
      },
      {
        "name": "adgenai",
        "pricing": "Freemium",
        "description": "Generate high-performing ad creatives and copy using AI. Best-for: Marketers, advertisers.",
        "url": "https://www.adgenai.com/",
        "icon": "fas fa-bullhorn",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972180/adgenai_txt5zd.jpg",
        "dateAdded": 1678665600000,
        "tags": [
          "adgenai",
          "utility",
          "freemium",
          "highperforming",
          "creatives",
          "copy",
          "bestfor",
          "marketers",
          "advertisers"
        ],
        "rating": 4.5,
        "reviewCount": "158+"
      }
    ]
  },
  {
    "id": "AI Prompts",
    "name": "AI Prompts Tools",
    "tools": [
      {
        "name": "FlowGPT",
        "pricing": "Freemium",
        "description": "Platform to discover, share, and use the best ChatGPT prompts.",
        "icon": "fas fa-lightbulb",
        "url": "https://flowgpt.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976592/flowgpt_cx6wp2.jpg",
        "dateAdded": 1678665600000,
        "tags": [
          "flowgpt",
          "ai prompts",
          "freemium",
          "discover",
          "share",
          "chatgpt",
          "prompts"
        ],
        "rating": 4.8,
        "reviewCount": "386+"
      },
      {
        "name": "Alicent AI",
        "pricing": "Freemium",
        "description": "Prompt generator and management tool for AI-enhanced productivity.",
        "icon": "fas fa-bolt",
        "url": "https://alicent.ai/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972204/Alicent_v2w1tq.jpg",
        "dateAdded": 1678924800000,
        "tags": [
          "alicent ai",
          "ai prompts",
          "freemium",
          "alicent",
          "prompt",
          "generator",
          "management",
          "aienhanced",
          "productivity"
        ],
        "rating": 4.3,
        "reviewCount": "346+"
      },
      {
        "name": "PromptBox",
        "pricing": "Freemium",
        "description": "Save, organize, and manage AI prompts in one place.",
        "icon": "fas fa-box-open",
        "url": "https://promptbox.ai/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986929/Promptbox_sj7ktu.jpg",
        "dateAdded": 1678924800000,
        "tags": [
          "promptbox",
          "ai prompts",
          "freemium",
          "save",
          "organize",
          "manage",
          "prompts",
          "one",
          "place"
        ],
        "rating": 4.1,
        "reviewCount": "125+"
      },
      {
        "name": "Promptbase",
        "pricing": "Freemium",
        "description": "Marketplace for buying and selling quality AI prompts.",
        "icon": "fas fa-store",
        "url": "https://promptbase.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763988707/Promptbase_vqswfa.jpg",
        "dateAdded": 1678924800000,
        "tags": [
          "promptbase",
          "ai prompts",
          "freemium",
          "marketplace",
          "buying",
          "selling",
          "quality",
          "prompts"
        ],
        "rating": 4,
        "reviewCount": "188+"
      },
      {
        "name": "Snack Prompt",
        "pricing": "Freemium",
        "description": "Platform with community-voted AI prompts for ChatGPT and other tools.",
        "icon": "fas fa-cookie-bite",
        "url": "https://snackprompt.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989592/snackprompt_g5vxyx.jpg",
        "dateAdded": 1679011200000,
        "tags": [
          "snack prompt",
          "ai prompts",
          "freemium",
          "snack",
          "prompt",
          "communityvoted",
          "prompts",
          "chatgpt",
          "tools"
        ],
        "rating": 4,
        "reviewCount": "240+"
      }
    ]
  },
  {
    "id": "AI Design",
    "name": "AI Design Tools",
    "tools": [
      {
        "name": "Flair AI",
        "pricing": "Freemium",
        "description": "AI design platform for creating branded product visuals in seconds.",
        "icon": "fas fa-star",
        "url": "https://flair.ai/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763976451/Flair_rjnzdn.jpg",
        "dateAdded": 1679184000000,
        "tags": [
          "flair ai",
          "ai design",
          "freemium",
          "flair",
          "design",
          "creating",
          "branded",
          "product",
          "visuals",
          "seconds"
        ],
        "rating": 4.3,
        "reviewCount": "383+"
      },
      {
        "name": "Designify",
        "pricing": "Freemium",
        "description": "AI-powered design enhancer that removes backgrounds and improves images.",
        "icon": "fas fa-wand-magic",
        "url": "https://www.designify.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763975482/Designify_ppxyzp.jpg",
        "dateAdded": 1679270400000,
        "tags": [
          "designify",
          "ai design",
          "freemium",
          "aipowered",
          "design",
          "enhancer",
          "removes",
          "backgrounds",
          "improves",
          "images"
        ],
        "rating": 4.8,
        "reviewCount": "365+"
      },
      {
        "name": "Clipdrop",
        "pricing": "Freemium",
        "description": "AI suite for image editing, background removal, relighting, and upscaling.",
        "icon": "fas fa-scissors",
        "url": "https://clipdrop.co/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973929/clipboard_mwyyou.jpg",
        "dateAdded": 1679529600000,
        "tags": [
          "clipdrop",
          "ai design",
          "freemium",
          "suite",
          "image",
          "editing",
          "background",
          "removal",
          "relighting",
          "upscaling"
        ],
        "rating": 4.6,
        "reviewCount": "425+"
      },
      {
        "name": "Autodraw",
        "pricing": "Freemium",
        "description": "AI experiment by Google that turns rough drawings into polished icons.",
        "icon": "fas fa-pen",
        "url": "https://www.autodraw.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972209/AutoDrawer_n3ux52.jpg",
        "dateAdded": 1679788800000,
        "tags": [
          "autodraw",
          "ai design",
          "freemium",
          "experiment",
          "google",
          "turns",
          "rough",
          "drawings",
          "into",
          "polished",
          "icons"
        ],
        "rating": 4.9,
        "reviewCount": "339+"
      },
      {
        "name": "Magician Design",
        "pricing": "Freemium",
        "description": "Figma plugin using AI to generate icons, copy, and other design elements.",
        "icon": "fas fa-magic",
        "url": "https://domore.ai/tools/magician.design",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985979/magician.design_s4ervz.jpg",
        "dateAdded": 1679788800000,
        "tags": [
          "magician design",
          "ai design",
          "freemium",
          "magician",
          "design",
          "figma",
          "plugin",
          "icons",
          "copy",
          "elements"
        ],
        "rating": 4.4,
        "reviewCount": "396+"
      },
      {
        "name": "Canva",
        "pricing": "Freemium",
        "description": "An all-in-one online design platform for creating social media posts, presentations, posters, and more.",
        "icon": "fas fa-palette",
        "url": "https://www.canva.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973783/canva_pdxbq8.jpg",
        "dateAdded": 1680220800000,
        "tags": [
          "canva",
          "ai design",
          "freemium",
          "allinone",
          "design",
          "creating",
          "social",
          "media",
          "posts",
          "presentations",
          "posters"
        ],
        "rating": 4.8,
        "reviewCount": "15,000+"
      },
      {
        "name": "Designs.ai",
        "pricing": "Freemium",
        "description": "An AI-powered creative suite for making logos, videos, banners, and mockups effortlessly.",
        "icon": "fas fa-brain",
        "url": "https://designs.ai/",
        "isNew": false,
        "comingSoon": false,
        "badge": "New",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763975483/designs_ehgk6n.jpg",
        "dateAdded": 1680307200000,
        "tags": [
          "designs.ai",
          "ai design",
          "freemium",
          "designsai",
          "aipowered",
          "creative",
          "suite",
          "making",
          "logos",
          "videos",
          "banners",
          "mockups",
          "effortlessly"
        ],
        "rating": 4.4,
        "reviewCount": "28+"
      },
      {
        "name": "Microsoft Designer",
        "pricing": "Freemium",
        "description": "A graphic design app that helps you create stunning designs and images with the power of AI.",
        "icon": "fab fa-microsoft",
        "url": "https://designer.microsoft.com/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986015/MicrosoftDesigner_jfglgv.jpg",
        "dateAdded": 1680480000000,
        "tags": [
          "microsoft designer",
          "ai design",
          "freemium",
          "microsoft",
          "designer",
          "graphic",
          "design",
          "helps",
          "you",
          "stunning",
          "designs",
          "images",
          "power"
        ],
        "rating": 4.9,
        "reviewCount": "257+"
      },
      {
        "name": "polotno Studio",
        "pricing": "Freemium",
        "description": "A free online design tool with AI features for creating graphics, presentations, and social media posts.It is also alternative for the canva ",
        "icon": "fas fa-object-group",
        "url": "https://studio.polotno.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763988694/Polotno_jtveal.jpg",
        "dateAdded": 1680652800000,
        "tags": [
          "polotno studio",
          "ai design",
          "freemium",
          "polotno",
          "studio",
          "design",
          "creating",
          "graphics",
          "presentations",
          "social",
          "media",
          "postsit",
          "also",
          "alternative",
          "canva"
        ],
        "rating": 4.7,
        "reviewCount": "20+"
      }
    ]
  },
  {
    "id": "Logo Generators",
    "name": "AI Logo Generator",
    "tools": [
      {
        "name": "Looka",
        "pricing": "Freemium",
        "description": "AI-powered logo maker that creates professional logos in minutes.",
        "url": "https://looka.com",
        "icon": "fas fa-copyright",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985212/looka_toqpfg.jpg",
        "dateAdded": 1680739200000,
        "tags": [
          "looka",
          "ai logo generator",
          "freemium",
          "aipowered",
          "logo",
          "maker",
          "creates",
          "professional",
          "logos",
          "minutes"
        ],
        "rating": 4.7,
        "reviewCount": "366+"
      },
      {
        "name": "LogoMaker",
        "pricing": "Freemium",
        "description": "Create custom logos with AI assistance.",
        "url": "https://www.logomaker.com",
        "icon": "fas fa-copyright",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985208/logomaker_tluf4c.jpg",
        "dateAdded": 1680825600000,
        "tags": [
          "logomaker",
          "ai logo generator",
          "freemium",
          "custom",
          "logos",
          "assistance"
        ],
        "rating": 4.3,
        "reviewCount": "124+"
      },
      {
        "name": "Hatchful by Shopify",
        "pricing": "Freemium",
        "description": "Free logo maker that helps you create a unique logo for your brand.",
        "url": "https://hatchful.shopify.com",
        "icon": "fas fa-copyright",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989528/Shopify_mbwke0.jpg",
        "dateAdded": 1681171200000,
        "tags": [
          "hatchful by shopify",
          "ai logo generator",
          "freemium",
          "hatchful",
          "shopify",
          "logo",
          "maker",
          "helps",
          "you",
          "unique",
          "your",
          "brand"
        ],
        "rating": 4.2,
        "reviewCount": "221+"
      },
      {
        "name": "Brandmark",
        "pricing": "Freemium",
        "description": "AI logo generator that creates unique logos based on your preferences.",
        "url": "https://brandmark.io",
        "icon": "fas fa-copyright",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972952/BrandMark_pxe66i.jpg",
        "dateAdded": 1681171200000,
        "tags": [
          "brandmark",
          "ai logo generator",
          "freemium",
          "logo",
          "generator",
          "creates",
          "unique",
          "logos",
          "your",
          "preferences"
        ],
        "rating": 4.5,
        "reviewCount": "482+"
      },
      {
        "name": "Logo Genie",
        "pricing": "Freemium",
        "description": "AI-powered logo design tool that generates logos based on your input.",
        "url": "https://www.logogenie.net/",
        "icon": "fas fa-copyright",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985201/logogenie_ehgmqd.jpg",
        "dateAdded": 1681257600000,
        "tags": [
          "logo genie",
          "ai logo generator",
          "freemium",
          "logo",
          "genie",
          "aipowered",
          "design",
          "generates",
          "logos",
          "your",
          "input"
        ],
        "rating": 4.7,
        "reviewCount": "282+"
      },
      {
        "name": "Stockimg AI",
        "pricing": "Freemium",
        "description": "Generative AI platform for creating stock images, logos, and posters.",
        "icon": "fas fa-images",
        "url": "https://stockimg.ai/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989685/StockImage_rj1bp8.jpg",
        "dateAdded": 1681689600000,
        "tags": [
          "stockimg ai",
          "ai logo generator",
          "freemium",
          "stockimg",
          "generative",
          "creating",
          "stock",
          "images",
          "logos",
          "posters"
        ],
        "rating": 4.1,
        "reviewCount": "367+"
      },
      {
        "name": "Namecheap Logo",
        "pricing": "Freemium",
        "description": "Free logo maker by Namecheap that uses AI to help build your brand design.",
        "icon": "fas fa-tag",
        "url": "https://www.namecheap.com/logo-maker/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986680/Namecheap_ttyitd.jpg",
        "dateAdded": 1681862400000,
        "tags": [
          "namecheap logo",
          "ai logo generator",
          "freemium",
          "namecheap",
          "logo",
          "maker",
          "uses",
          "build",
          "your",
          "brand",
          "design"
        ],
        "rating": 4.3,
        "reviewCount": "256+"
      }
    ]
  },
  {
    "id": "Social Media",
    "name": "AI Social Media Tools",
    "tools": [
      {
        "name": "SocialBee",
        "pricing": "Freemium",
        "description": "AI-powered social media management tool for scheduling and content creation.",
        "url": "https://socialbee.io",
        "icon": "fas fa-share-alt",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763989605/SocialBee_yvkpax.jpg",
        "dateAdded": 1682380800000,
        "tags": [
          "socialbee",
          "ai social media",
          "freemium",
          "aipowered",
          "social",
          "media",
          "management",
          "scheduling",
          "content",
          "creation"
        ],
        "rating": 4.8,
        "reviewCount": "288+"
      },
      {
        "name": "Lately AI",
        "pricing": "Freemium",
        "description": "AI social media management platform that helps you create and schedule posts across multiple platforms.",
        "url": "https://www.lately.ai",
        "icon": "fas fa-share-alt",
        "isNew": false,
        "comingSoon": false,
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985133/Lately_yqyhyx.jpg",
        "dateAdded": 1682467200000,
        "tags": [
          "lately ai",
          "ai social media",
          "freemium",
          "lately",
          "social",
          "media",
          "management",
          "helps",
          "you",
          "schedule",
          "posts",
          "across",
          "multiple",
          "platforms"
        ],
        "rating": 4.7,
        "reviewCount": "364+"
      },
      {
        "name": "Postly",
        "pricing": "Freemium",
        "description": "AI-powered social media management tool for scheduling and content creation.",
        "url": "https://postly.ai/",
        "icon": "fas fa-share-alt",
        "isNew": true,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763987204/Postly_c0cwwm.jpg",
        "dateAdded": 1682467200000,
        "tags": [
          "postly",
          "ai social media",
          "freemium",
          "aipowered",
          "social",
          "media",
          "management",
          "scheduling",
          "content",
          "creation"
        ],
        "rating": 4.8,
        "reviewCount": "169+"
      },
      {
        "name": "Taplio",
        "pricing": "Freemium",
        "description": "AI-powered LinkedIn content creation and growth tool for personal branding.",
        "icon": "fas fa-network-wired",
        "url": "https://taplio.com/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990425/Taplio_xgrxoq.jpg",
        "dateAdded": 1682467200000,
        "tags": [
          "taplio",
          "ai social media",
          "freemium",
          "aipowered",
          "linkedin",
          "content",
          "creation",
          "growth",
          "personal",
          "branding"
        ],
        "rating": 4.7,
        "reviewCount": "193+"
      },
      {
        "name": "Typefully",
        "pricing": "Freemium",
        "description": "Tool for crafting, scheduling, and analyzing Twitter threads with AI help.",
        "icon": "fas fa-feather-alt",
        "url": "https://typefully.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990536/Typefully_dgyoq6.jpg",
        "dateAdded": 1682726400000,
        "tags": [
          "typefully",
          "ai social media",
          "freemium",
          "crafting",
          "scheduling",
          "analyzing",
          "twitter",
          "threads"
        ],
        "rating": 4.6,
        "reviewCount": "320+"
      },
      {
        "name": "Hypefury",
        "pricing": "Freemium",
        "description": "Social media content manager for scheduling, auto-retweets, and growth insights.",
        "icon": "fas fa-fire",
        "url": "https://hypefury.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763983995/HypeFury_bmjew9.jpg",
        "dateAdded": 1682985600000,
        "tags": [
          "hypefury",
          "ai social media",
          "freemium",
          "social",
          "media",
          "content",
          "manager",
          "scheduling",
          "autoretweets",
          "growth",
          "insights"
        ],
        "rating": 4.4,
        "reviewCount": "141+"
      },
      {
        "name": "TweetHunter",
        "pricing": "Freemium",
        "description": "AI-powered Twitter tool to help you write better tweets, schedule, and grow.",
        "icon": "fas fa-bullhorn",
        "url": "https://tweethunter.io/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990694/TweetHunter_odv2dx.jpg",
        "dateAdded": 1683244800000,
        "tags": [
          "tweethunter",
          "ai social media",
          "freemium",
          "aipowered",
          "twitter",
          "you",
          "write",
          "tweets",
          "schedule",
          "grow"
        ],
        "rating": 4.8,
        "reviewCount": "263+"
      },
      {
        "name": "Persona",
        "pricing": "Freemium",
        "description": "AI tool to create and manage multiple social media personas for content creation.",
        "icon": "fas fa-user-friends",
        "url": "https://www.personal.ai/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763987404/PersonalAI_m8orff.jpg",
        "dateAdded": 1683331200000,
        "tags": [
          "persona",
          "ai social media",
          "freemium",
          "manage",
          "multiple",
          "social",
          "media",
          "personas",
          "content",
          "creation"
        ],
        "rating": 4.7,
        "reviewCount": "277+"
      }
    ]
  },
  {
    "id": "Productivity",
    "name": "AI Productivity Tools",
    "tools": [
      {
        "name": "Merlin",
        "pricing": "Freemium",
        "description": "AI copilot Chrome extension that brings ChatGPT to any site for fast productivity.",
        "icon": "fas fa-rocket",
        "url": "https://www.getmerlin.in/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986003/Merlin_ssm6gl.jpg",
        "dateAdded": 1683849600000,
        "tags": [
          "merlin",
          "ai productivity",
          "freemium",
          "copilot",
          "chrome",
          "extension",
          "brings",
          "chatgpt",
          "any",
          "site",
          "productivity"
        ],
        "rating": 4.7,
        "reviewCount": "155+"
      },
      {
        "name": "TinyWow",
        "pricing": "Free",
        "description": "Free tools powered by AI for PDF editing, image conversion, and productivity tasks.",
        "icon": "fas fa-tools",
        "url": "https://tinywow.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990461/Tinywow_qcbvcs.jpg",
        "dateAdded": 1683849600000,
        "tags": [
          "tinywow",
          "ai productivity",
          "free",
          "tools",
          "pdf",
          "editing",
          "image",
          "conversion",
          "productivity",
          "tasks"
        ],
        "rating": 4.3,
        "reviewCount": "60+"
      },
      {
        "name": "Notion AI",
        "pricing": "Freemium",
        "description": "Integrated AI inside Notion to help write, summarize, brainstorm, and more.",
        "icon": "fas fa-brain",
        "url": "https://www.notion.so/product/ai",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763986686/notion_vvyaow.jpg",
        "dateAdded": 1683936000000,
        "tags": [
          "notion ai",
          "ai productivity",
          "freemium",
          "notion",
          "integrated",
          "inside",
          "write",
          "summarize",
          "brainstorm"
        ],
        "rating": 4.8,
        "reviewCount": "10,000+"
      },
      {
        "name": "Adobe Sensei",
        "pricing": "Freemium",
        "description": "Adobe’s AI engine powering intelligent features across their creative apps.",
        "icon": "fas fa-robot",
        "url": "https://www.adobe.com/sensei.html",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763972959/business.adobe_lwhesw.jpg",
        "dateAdded": 1684022400000,
        "tags": [
          "adobe sensei",
          "ai productivity",
          "freemium",
          "adobe",
          "sensei",
          "adobes",
          "engine",
          "powering",
          "across",
          "their",
          "creative",
          "apps"
        ],
        "rating": 4.7,
        "reviewCount": "292+"
      },
      {
        "name": "Mem",
        "pricing": "Freemium",
        "description": "AI-powered note-taking app that helps you organize your thoughts and ideas.",
        "icon": "fas fa-sticky-note",
        "url": "https://mem.ai/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763985999/Mem_akrws9.jpg",
        "dateAdded": 1684281600000,
        "tags": [
          "mem",
          "ai productivity",
          "freemium",
          "aipowered",
          "notetaking",
          "helps",
          "you",
          "organize",
          "your",
          "thoughts",
          "ideas"
        ],
        "rating": 4.1,
        "reviewCount": "473+"
      },
      {
        "name": "Trello",
        "pricing": "Freemium",
        "description": "Project management tool with AI features for task automation and organization.",
        "icon": "fas fa-tasks",
        "url": "https://trello.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990495/Trello_n8fcg9.jpg",
        "dateAdded": 1684368000000,
        "tags": [
          "trello",
          "ai productivity",
          "freemium",
          "project",
          "management",
          "task",
          "organization"
        ],
        "rating": 4.2,
        "reviewCount": "361+"
      },
      {
        "name": "Todoist",
        "pricing": "Freemium",
        "description": "AI-powered task management app that helps you  organize your to-do lists and projects.",
        "icon": "fas fa-list",
        "url": "https://todoist.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990474/Todoist_keli8v.jpg",
        "dateAdded": 1684540800000,
        "tags": [
          "todoist",
          "ai productivity",
          "freemium",
          "aipowered",
          "task",
          "management",
          "helps",
          "you",
          "organize",
          "your",
          "todo",
          "lists",
          "projects"
        ],
        "rating": 4.8,
        "reviewCount": "500+"
      },
      {
        "name": "ClickUp",
        "pricing": "Freemium",
        "description": "All-in-one productivity platform with AI features  for task management, docs, and goals.",
        "icon": "fas fa-tasks",
        "url": "https://clickup.com/",
        "isNew": false,
        "comingSoon": false,
        "badge": "Recommended",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973921/ClickUp_x1sa8x.jpg",
        "dateAdded": 1684972800000,
        "tags": [
          "clickup",
          "ai productivity",
          "freemium",
          "allinone",
          "productivity",
          "task",
          "management",
          "docs",
          "goals"
        ],
        "rating": 4.5,
        "reviewCount": "374+"
      },
      {
        "name": "Tidy",
        "pricing": "Freemium",
        "description": "AI-powered workspace management tool to organize tasks, notes, and projects collaboratively.",
        "icon": "fas fa-folder-open",
        "url": "https://tidyapp.io/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763990457/Tidyapp_c1zs2b.jpg",
        "dateAdded": 1685318400000,
        "tags": [
          "tidy",
          "ai productivity",
          "freemium",
          "aipowered",
          "workspace",
          "management",
          "organize",
          "tasks",
          "notes",
          "projects",
          "collaboratively"
        ],
        "rating": 4.4,
        "reviewCount": "239+"
      },
      {
        "name": "wisprFlow",
        "pricing": "Freemium",
        "description": "AI-powered workflow automation tool to streamline repetitive tasks and boost productivity,Ai voice detection",
        "icon": "fas fa-sync-alt",
        "url": "https://www.wisprflow.com/",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763991408/WisprFlow_eydfwx.jpg",
        "dateAdded": 1685318400000,
        "tags": [
          "wisprflow",
          "ai productivity",
          "freemium",
          "aipowered",
          "workflow",
          "streamline",
          "repetitive",
          "tasks",
          "boost",
          "productivityai",
          "voice",
          "detection"
        ],
        "rating": 4.9,
        "reviewCount": "272+"
      }
    ]
  },
  {
    "id": "subtitles-and-captions",
    "name": "Subtitles and Captions",
    "tools": [
      {
        "name": "Captions.ai",
        "pricing": "Freemium",
        "description": "AI tool to automatically generate captions and subtitles for videos in multiple languages.",
        "url": "https://captions.ai/",
        "icon": "fas fa-closed-captioning",
        "isNew": true,
        "comingSoon": false,
        "badge": "new",
        "image": "https://res.cloudinary.com/drwvqhof7/image/upload/v1763973790/captions_qb23mq.jpg",
        "dateAdded": 1761955200000,
        "tags": [
          "captions.ai",
          "subtitles and captions",
          "freemium",
          "captionsai",
          "captions",
          "subtitles",
          "videos",
          "multiple",
          "languages"
        ],
        "rating": 4.1,
        "reviewCount": "448+"
      }
    ]
  }
];
export default toolsData;